import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroupDirective, NgForm, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { FloatLabelType } from '@angular/material/form-field';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { FirmModel, UserDetailModel } from 'countable@model';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { FullAddressModel } from 'src/app/model/common/full-address.model';
import { environment } from '../../../../environments/environment';
import { OnboardingModel } from '../../../model/firm/onboarding.model';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';
import { ClientService } from '../../../services/client.service';
import { FirmService } from '../../../services/firm.service';
import { UserService } from '../../../services/user.service';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-firm-onboarding',
  templateUrl: './firm-onboarding.component.html',
  styleUrls: ['./firm-onboarding.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
  standalone: false
})
export class FirmOnboardingComponent {

  @ViewChild('allAssignMenu') allAssignMenu: MatMenuTrigger;
  @ViewChild('DeleteActionDialog') deleteActionDialog: TemplateRef<any>;
  @ViewChild('DeleteActionClientDialog') deleteActionClientDialog: TemplateRef<any>;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;
  @ViewChild('emailField') _emailEl: ElementRef;
  @ViewChild('emailFieldStep2') _emailStep2El: ElementRef;
  @ViewChild('entityField') _entityEl: ElementRef;
  @ViewChild('howtoEdit') howtoEdit: TemplateRef<any>;
  @ViewChild('csvReader') csvReader: any;
  @ViewChild('alertDialog') alertDialog: TemplateRef<any>;
  @ViewChild('alertDialog1') alertDialog1: TemplateRef<any>;
  @ViewChild('uploadCSV') cnfUploadCsv: TemplateRef<any>;
  @ViewChild('uploadCSVCli') cnfUploadCsvCli: TemplateRef<any>;
  @ViewChild('step2Form') step2Form: NgForm;
  @ViewChild('step3Form') step3Form: NgForm;
  @ViewChild('importCsvDialog') importCsvDialog: TemplateRef<any>;
  @ViewChild('howToEditCsv') howToEditCsv: TemplateRef<any>;
  @ViewChild('stepper') stepper: MatStepper;

  public records: any = [];
  firm: FirmModel;
  user: UserDetailModel | null;
  isLoaded = false;
  zipCode: any;
  step4Columns: string[] = ['checkbox', 'membername', 'role', 'title', 'email'];
  displayedColumns3: string[] = ['cliId', 'lentity', 'tyentity', 'incDate', 'name', 'emailcli', 'busNo', 'cellNoCli', 'partners', 'actions'];
  firmSuperAdminForm: UntypedFormGroup;
  partnerDetailsForm: UntypedFormGroup;
  clientDetailsForm: UntypedFormGroup;
  firmDetails: any = {};
  token: any;
  states: any = [];
  countries: any = [];
  toggleMenu: boolean = true;
  processType: any = 'manual';
  addPartnersColumns: string[] = ['id', 'role', 'name', 'title', 'email', 'businessNumber', 'cell', 'license', 'access', 'rate', 'actions'];
  addPartnersColumns1: string[] = ['id', 'role', 'name', 'title', 'email', 'businessNumber', 'cell', 'rate', 'license', 'access', 'actions'];
  addClientColumns: string[] = ['checkbox', 'id', 'legalentityname', 'typeofentity', 'incorporationdate', 'name', 'email', 'businessPhoneNo', 'cellPhoneNo', 'partner', 'actions'];
  isInfoWrapperExpanded: boolean = true;
  partnersList: any = [];
  uploadSuccess: boolean = true;
  clientsList: any = [];
  typeOfEntityDetails: any = [];
  subtypeOfEntityDetails: any = [];
  accessType: any = [];
  partnersGridData: any = [];
  staffData: any = [];
  partnerData: any = [];
  actualPartnersGridData: any = [];
  clientsGridData: any = [];
  delClient: any;
  clientsData: any = [];
  customDateTitle: any = 'Incorporation Date';
  maxIncorpDate: any = new Date();
  showStep1: any = true; // change after third step
  showStep2: any = false;
  showStep3: any = false; // change after third step
  showStep4: any = false;
  partnerName: any = '';
  useraccountId: any;
  staffList: any = [];
  inviteAll: any = true;
  bucketName: any;
  pegSubscriber = [{'pegValue': 0, 'pegName': 'Yes'}, {'pegValue': 1, 'pegName': 'No'}];
  addPartnerIndex: any = 0;
  addClientIndex: any = 0;
  isCompletedStep1 = false; // change after third step
  isCompletedStep2 = false; // change after third step
  isCompletedStep3 = false;
  isEditPartner = false;
  partnersImportGridData: any;
  actualPartnersImportGridData: any = [];
  partnerEmailStatus = false;
  partnerImportEmailStatus = false;
  partnerLicenseNostatus = false;
  isSelectedPartner = false;
  partnerImportIdStatus = false;
  partnerIdStatus = false;
  partnerImportLicenseStatus = false;
  engPartner: string;
  clientsImportGridData: any;
  clientImportEmailStatus: boolean;
  clientEmailStatus: boolean;
  actualClientsGridData: any = [];
  actualClientsImportGridData: any = [];
  isEditClient = false;
  isEnableAssignButton = false;
  selectedClients: any = [];
  isCheckedAll = false;
  inviteGridData: MatTableDataSource<any>;
  backType: any;
  formType: string;
  partnerCSVUrl: any;
  clientCSVUrl: any;
  searchFilter: string;
  invitedPartners: any;
  isShowDesignation: boolean;
  clientIdStatus: boolean;
  clientImportIdStatus: boolean;
  clientImportEntityStatus: boolean;
  partnerImportColumns1 = ['Title', 'Member ID', 'First Name', 'Last Name', 'Email', 'Business Phone', 'Cell Phone', 'License No', 'Hourly Rate', 'Category', 'Access Type'];
  clientImportColumns1 = ['Client Id', 'Entity Name', 'Entity Type ', 'Incorporation Date', 'First Name', 'Last Name', 'Email', 'Business Phone', 'Cell Phone', 'Address', 'City', 'State/Province', 'Country', 'Postal Code', 'Engagement Partner', 'Engagement Partner Email', 'Group Name'];
  USAclientImportColumns = ['Client Id', 'Entity Name', 'Entity Type ', 'Sub Entity', 'Incorporation Date', 'First Name', 'Last Name', 'Email', 'Business Phone', 'Cell Phone', 'Jurisdiction Of Entity', 'Address', 'City', 'State/Province', 'Country', 'Postal Code', 'Engagement Partner', 'Engagement Partner Email', 'Group Name'];
  onlyNumberPattern = /^[0-9]*$/;
  alphanumericPattern = /^[a-z0-9]+$/i;
  alphanumericDecimalPattern = /^[a-z0-9. ]+$/i;
  isCitiesLoading2: boolean = false;
  isCitiesLoading3: boolean = false;
  isInvalidEmail2: boolean = false;
  isInvalidEmail3: boolean = false;
  isInvalidId2: boolean = false;
  isInvalidId3: boolean = false;
  isInvalidLicense: boolean = false;
  partnerId: any;
  partnerLicenseNo: any;
  partnerEmail: any;
  partnerFullName: string;
  isInvalidName2 = false;
  fromBackType: string;
  partnerNameStatus = false;
  clientId: any;
  clientEmail: any;
  downloadPDFFile: any;
  userData: any;
  disableTeam: boolean = false;
  staffDisable: boolean = false;
  offSwitchTabs: boolean = true;
  isReadonly = false;
  isDisable = false;
  assignedPartner: any;
  activeAssignPartner: boolean = false;
  activeUnAssignPartner: boolean = false;
  emailId: any;
  memberId: any;
  licenseNo: any;
  errorMessage: any;
  clientErrMessage: any;
  disableBack: boolean = false;
  teamMemberData: any;
  confirmMessage: string;
  legalEntityName: any;
  isInvalidClientName: boolean = false;
  clientDetailsObj: any;
  isEmailError: boolean = false;
  isEmailS2Error: boolean = false;
  isEntityError: boolean = false;
  selectedAccessType: any = {};
  isShowPEGSubcriberDetail: boolean = false;
  UserRole: any = [];
  envURL: any;
  RequirefieldValidation: boolean;
  isLinear = false;
  hideRequiredControl = new UntypedFormControl(false);
  floatLabelControl = new UntypedFormControl('auto' as FloatLabelType);
  options = this._formBuilder.group({
    hideRequired: this.hideRequiredControl,
    floatLabel: this.floatLabelControl
  });
  countryCodeForGoogleMap: string;
  public autoCompleteSuggestions: WritableSignal<FullAddressModel[]> = signal<FullAddressModel[]>([]);
  private destroyRef = inject(DestroyRef);

  constructor(private fb: UntypedFormBuilder, private sharedService: SharedService, private apiService: ApiService,
              private toaster: ToastrService, private router: Router,
              private _cd: ChangeDetectorRef, private datePipe: DatePipe, public dialog: MatDialog,
              private authService: AuthService, private firmService: FirmService, private _formBuilder: UntypedFormBuilder,
              private userApiService: UserService, private clientService: ClientService) {
    this.firmService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(firm => {
      if (firm) {
        this.firm = firm;
        if (firm.onboarded) {
          this.router.navigate(['/dashboard/members/Dashboard']).then();
        }
      }
    });
    this.authService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(status => {
      if (!status) {
        return;
      }
      this.user = this.authService.getUserDetail();
      this.bucketName = this.user.s3BucketName;
      this.partnerCSVUrl = this.sharedService.getS3url(this.bucketName, 'csvtemplate/v1/AccountTeamImport.csv');
      this.clientCSVUrl = this.sharedService.getS3url(this.bucketName, 'csvtemplate/v1/AccountClientImport_v2.csv');
      if (this.user.origin_country_id == 226) {
        this.clientCSVUrl = this.sharedService.getS3url(this.bucketName, 'csvtemplate/v1/AccountClientImport_USA.csv');
        this.addClientColumns = ['checkbox', 'id', 'legalentityname', 'typeofentity', 'Subtypeofentity', 'incorporationdate', 'name', 'email', 'businessPhoneNo', 'cellPhoneNo', 'partner', 'actions'];
        this.displayedColumns3 = ['cliId', 'lentity', 'tyentity', 'subtyentity', 'incDate', 'name', 'emailcli', 'busNo', 'cellNoCli', 'partners', 'actions'];
      }
      this.countryCodeForGoogleMap = this.user.origin_country_id == 226 ? 'us' : 'ca';
      if (this.user && this.user.useracctid) {
        this.useraccountId = this.user.useracctid;
        // check if the required data is loaded
        this.isLoaded = true;
        this.loadFirmDetailsForm();
        this.loadPartnerForm();
        this.loadClientForm();
        this.getfirmData();
        this.getAccessType();
        this.getUserRoleDetails();
      }
      this.roleChange();
      this.disable();
    });
  }

  get step2Email() {
    return this.partnerDetailsForm.get('partnerEmail');
  }

  get ClientEmail() {
    return this.clientDetailsForm.get('clientEmail');
  }

  get step3Date() {
    return this.clientDetailsForm.get('incorporationDate');
  }

  errorMsg(value, step3DateValue) {
    this.clientDetailsForm.controls['incorporationDate'].setValue(value);
    if (step3DateValue) {
      this.toaster.error('Provide' + ' ' + this.customDateTitle + ' ' + 'is wrong');
    }
  }

  getUserRoleDetails() {
    this.userApiService.getAllUserAccessType().subscribe({
      next: res => {
        if (res) {
          this.UserRole = JSON.parse(res).UserRole;
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  sideMenutoggleDrawer() {
    this.isInfoWrapperExpanded = !this.isInfoWrapperExpanded;
  }

  toggleDrawer() {
    this.toggleMenu = !this.toggleMenu;
  }

  // On load step-1
  loadFirmDetailsForm() {
    let adminEmail = this.firm?.superUserEmail;
    let adminFirstName = this.user.firstname;
    let adminLastName = this.user.lastname;
    let firmName = this.firm?.name;
    let cellPhoneNo = this.user.cellphonenumber;
    this.firmSuperAdminForm = this.fb.group({
      'firmName': new UntypedFormControl(firmName, [Validators.required]),
      'pegId': new UntypedFormControl(null),
      'pegLicenseNo': new UntypedFormControl(''),
      'pegExpiryDate': new UntypedFormControl(''),
      'address': new UntypedFormControl('', [Validators.required]),
      'country': new UntypedFormControl('', [Validators.required]),
      'state': new UntypedFormControl('', [Validators.required]),
      'city': new UntypedFormControl('', [Validators.required]),
      'zipCode': new UntypedFormControl('', [Validators.required]),
      'firstName': new UntypedFormControl(adminFirstName, [Validators.required]),
      'lastName': new UntypedFormControl(adminLastName),
      'email': new UntypedFormControl(adminEmail, [Validators.required, Validators.pattern(environment.EMAIL_REG_EXP)]),
      'businessPhone': new UntypedFormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
      'cellPhone': new UntypedFormControl(cellPhoneNo, [Validators.minLength(14), Validators.maxLength(14)]),
      'pMemberId': new UntypedFormControl(''),
      'pLicenseNo': new UntypedFormControl(''),
      'pHourlyRate': new UntypedFormControl(''),
      'pTitle': new UntypedFormControl('')
    });
    this.getCountriesList();
  }

  onPegSubscriberChange() {
    if (this.firmSuperAdminForm.get('pegId').value === 'Yes') {
      this.isShowPEGSubcriberDetail = true;
    } else {
      this.isShowPEGSubcriberDetail = false;
      this.firmSuperAdminForm.get('pegLicenseNo').setValue('');
      this.firmSuperAdminForm.get('pegExpiryDate').setValue('');
    }
  }

  // get call api for step-1 account
  getfirmData() {
    this.firmService.getFirmFourSteps(this.useraccountId).subscribe({
      next: res => {
        if (!res) {
          return;
        }
        const result = JSON.parse(res);
        if (result) {
          if (result.length === 0) {
            return;
          }
          result.firmdetails.pegsubscriber === 'Yes' ? this.isShowPEGSubcriberDetail = true : this.isShowPEGSubcriberDetail = false;
          this.firmSuperAdminForm.get('address').setValue(result.firmdetails.address);
          this.firmSuperAdminForm.get('cellPhone').setValue(result.firmdetails.cellphone);
          this.firmSuperAdminForm.get('zipCode').setValue(result.firmdetails.zipcode);
          this.firmSuperAdminForm.get('country').setValue(result.firmdetails.countryname);
          this.firmSuperAdminForm.get('state').setValue(result.firmdetails.statename);
          this.firmSuperAdminForm.get('city').setValue(result.firmdetails.cityname);
          this.firmSuperAdminForm.get('firmName').setValue(result.firmdetails.firmName);
          this.firmSuperAdminForm.get('firstName').setValue(result.firmdetails.firstname);
          this.firmSuperAdminForm.get('lastName').setValue(result.firmdetails.lastname);
          this.firmSuperAdminForm.get('email').setValue(result.firmdetails.emailid);
          this.firmSuperAdminForm.get('businessPhone').setValue(result.firmdetails.bphone);
          this.firmSuperAdminForm.get('pegId').setValue(result.firmdetails.pegsubscriber);
          this.firmSuperAdminForm.get('pegLicenseNo').setValue(result.firmdetails.peglicencenumber);
          this.firmSuperAdminForm.get('pegExpiryDate').setValue(result.firmdetails.pegexpirydate);
          this.firmSuperAdminForm.get('pMemberId').setValue(result.firmdetails.pMemberId);
          this.firmSuperAdminForm.get('pLicenseNo').setValue(result.firmdetails.pLicenseNo);
          this.firmSuperAdminForm.get('pHourlyRate').setValue(result.firmdetails.pHourlyRate);
          this.firmSuperAdminForm.get('pTitle').setValue(result.firmdetails.pTitle);
          let partnerGridList: any = [];
          this.partnerData = result.partnersList.map(partner => (
            {
              'id': partner.memberid,
              'partnerFirstName': partner.firstname,
              'partnerLastName': partner.lastname,
              'partnerEmail': partner.emailAddress,
              'partnerBusinessPhone': partner.businessNo,
              'PartnerCellNo': partner.phoneNo,
              'licenseNo': partner.licenseNo,
              'hourlyRate': partner.hourlyrate,
              'role': 'Partner',
              'clientList': null,
              'partnerUserAcctId': 0,
              'title': partner.designationName,
              'loginid': this.useraccountId,
              'fullName': partner.firstname + ' ' + partner.lastname,
              'accessType': partner.accessType,
              'officelocation': 'Canada'
            }
          ));
          this.partnerData.forEach(obj => {
            if (obj.role && obj.role.toLowerCase() === 'partner') {
              if (obj.hourlyRate == 'NaN' || obj.hourlyRate == null) {
                obj.hourlyRate = '';
              }
              obj.isInvite = true;
              this.addPartnerIndex = this.addPartnerIndex + 1;
              obj.index = this.addPartnerIndex;
              // added extra key value to identify process type(import,manual) of uploaded data or added data object
              // (Abhay)
              obj.processType = 'manual';
              partnerGridList.push(obj);
              this.partnersList.push(obj);
            } else {
              obj.isInvite = true;
              if (obj.hourlyRate == 'NaN' || obj.hourlyRate == null) {
                obj.hourlyRate = '';
              }
              this.addPartnerIndex = this.addPartnerIndex + 1;
              obj.index = this.addPartnerIndex;
              // added extra key value to identify process type(import,manual) of uploaded data or added data object
              // (Abhay)
              obj.processType = 'manual';
              partnerGridList.push(obj);
              this.partnersList.push(obj);
            }
          });
          let staffGridList: any = [];
          this.staffData = result.staffList.map(staff => (
            {
              'id': staff.memberid,
              'partnerFirstName': staff.firstName,
              'partnerLastName': staff.lastName,
              'partnerEmail': staff.emailAddress,
              'partnerBusinessPhone': staff.businessNo,
              'PartnerCellNo': staff.phoneNo,
              'licenseNo': staff.licenseNo,
              'hourlyRate': staff.hourlyrate,
              'role': 'Staff',
              'clientList': null,
              'partnerUserAcctId': 0,
              'loginid': this.useraccountId,
              'title': staff.designationName,
              'fullName': staff.firstName + ' ' + staff.lastName,
              'accessType': staff.accessType,
              'officelocation': 'Canada'
            }
          ));
          this.staffData.forEach(obj => {
            if (obj.role && obj.role.toLowerCase() === 'partner') {
              if (obj.hourlyRate == 'NaN' || obj.hourlyRate == null) {
                obj.hourlyRate = '';
              }
              obj.isInvite = true;
              this.addPartnerIndex = this.addPartnerIndex + 1;
              obj.index = this.addPartnerIndex;
              //added extra key value to identify process type(import,manual) of uploaded data or added data object
              // (Abhay)
              obj.processType = 'manual';
              staffGridList.push(obj);
              this.staffList.push(obj);
            } else {
              obj.isInvite = true;
              if (obj.hourlyRate == 'NaN' || obj.hourlyRate == null) {
                obj.hourlyRate = '';
              }
              this.addPartnerIndex = this.addPartnerIndex + 1;
              obj.index = this.addPartnerIndex;
              //added extra key value to identify process type(import,manual) of uploaded data or added data object
              // (Abhay)
              obj.processType = 'manual';
              staffGridList.push(obj);
              this.staffList.push(obj);
            }
          });

          this.partnersGridData.push(...partnerGridList, ...staffGridList);
          this.isCompletedStep2 = this.partnersGridData.length != 0;
          this.onPartnersGridLoad(this.partnersGridData);
          let clientGridList: any = [];
          this.clientsData = result.clientsList.map(client => (
            {
              'clientId': client.clientid ? client.clientid : client.pid,
              'legalEntityName': client.entityname,
              'typeOfEntity': client.typeOfEntity,
              'typeOfEntityName': client.entitytype,
              'subentitysectionData': client.subentitysectionData,
              'subentityname': client.subentityname,
              'incorporationDate': client.pincorporationdate,
              'groupName': client.groupName,
              'clientFirstName': client.firstname,
              'clientLastName': client.lastname,
              'clientEmail': client.pemailadd,
              'clientCellPhone': client.pcphonenumber,
              'clientBusinessPhone': client.pbphonenumber,
              'clientAddress': client.address,
              'clientCountry': client.Countryname ? client.Countryname : client.clientCountry,
              'clientState': client.Statename ? client.Statename : client.clientState,
              'clientCity': client.Cityname ? client.Statename : client.clientCity,
              'clientZipCode': client.clientZipCode,
              'engPartnerEmail': client.engPartnerEmail,
              'engPartnerName': client.engPartnerName,
              'uniqueId': client.clientid,
              'role': client.role
            }
          ));

          this.partnerData.filter(e => {
            this.clientsData.filter(c => {
              if (c.engPartnerEmail == e.partnerEmail) {
                c.engPartnerName = e.fullName;
              } else if (c.engPartnerEmail !== e.partnerEmail && c.engPartnerName == undefined) {
                c.engPartnerName = 'Unassigned';
              }
            });
          });

          this.clientsData.forEach(obj => {
            this.addClientIndex = this.addClientIndex + 1;
            obj.index = this.addClientIndex;
            //added extra key value to identify process type(import,manual) of uploaded data or added data object
            // (Abhay)
            obj.processType = 'manual';
            clientGridList.push(obj);
            this.clientsList.push(obj);

          });
          this.clientsGridData.push(...clientGridList);
          this.isCompletedStep3 = this.clientsGridData.length != 0;
          this.onClientsGridLoad(this.clientsGridData);
        } else {
          this.toaster.warning('Fail to load data');
        }
        this._cd.detectChanges();
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  //Step 2 partner form
  loadPartnerForm() {
    this.partnerDetailsForm = this.fb.group({
      'id': new UntypedFormControl('', {updateOn: 'blur'}),
      'partnerFirstName': new UntypedFormControl('', [Validators.required]),
      'partnerLastName': new UntypedFormControl('', [Validators.required]),
      'partnerEmail': new UntypedFormControl('', [Validators.required, Validators.pattern(environment.EMAIL_REG_EXP)]),
      'partnerBusinessPhone': new UntypedFormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
      'PartnerCellNo': new UntypedFormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
      'licenseNo': new UntypedFormControl(''),
      'hourlyRate': new UntypedFormControl(''),
      'role': new UntypedFormControl('', [Validators.required]),
      'title': new UntypedFormControl('', [Validators.required]),
      'designation': new UntypedFormControl(''),
      'uniqueId': new UntypedFormControl(''),
      'accessType': new UntypedFormControl()
    });
  }

  roleChange() {
    this.partnerDetailsForm.get('role').valueChanges.subscribe(role => {
      if (role != 'Staff') {
        this.partnerDetailsForm.get('designation').reset();
        this.partnerDetailsForm.get('designation').clearValidators();
        this.partnerDetailsForm.get('designation').updateValueAndValidity();
        this.isShowDesignation = false;
      } else {
        this.partnerDetailsForm.get('designation').setValidators([Validators.required]);
        this.partnerDetailsForm.get('designation').updateValueAndValidity();
        this.isShowDesignation = true;
      }
    });
  }

  validateStep2Email() {
    this.isInvalidEmail2 = true;
    const newEmail = this.partnerDetailsForm.get('partnerEmail').value;
    if (this.partnerEmail === newEmail) {
      this.isInvalidEmail2 = false;
      return;
    }
    if (newEmail && newEmail.match(environment.EMAIL_REG_EXP)) {
      if (this.clientsGridData.filter(element => newEmail === element.clientEmail).length > 0 ||
        this.partnersGridData.filter(element => newEmail === element.partnerEmail).length > 0) {
        this.isInvalidEmail2 = true;
        this._emailStep2El.nativeElement.focus();
        this.isEmailS2Error = true;
        this.toaster.error('Email Address already exists. Please use another email');
        return;
      }
      this.firmService.validateEmail(newEmail, null).subscribe(res => {
        if (res.status === 200) {
          this.isInvalidEmail2 = false;
          this.isEmailS2Error = false;
        } else {
          this.isInvalidEmail2 = true;
          this._emailStep2El.nativeElement.focus();
          this.isEmailS2Error = true;
          this.toaster.error('Email Address already exists. Please use another email');
        }
      });
    }
  }

  // -------------------------------Client entity-name Validation----------------------------------------------

  validateStep2Id() {
    const memberId: string = this.partnerDetailsForm.get('id').value;
    if (!memberId || memberId.trim().length === 0 || this.partnerId === memberId) {
      this.isInvalidId2 = false;
      return;
    }
    if (!memberId.match(this.alphanumericPattern)) {
      this.isInvalidId2 = true;
      this.toaster.error('Member ID already exists');
      return;
    }
    this.firmService.validateMemberId(memberId).subscribe(res => {
      if (res.status === 204) {
        this.isInvalidId2 = false;
      } else {
        this.isInvalidId2 = true;
        this.toaster.error('Member ID already exists');
      }
    });
  }

  validateStep2LicenseNo() {
    const licenseNo = this.partnerDetailsForm.get('licenseNo').value;
    if (!licenseNo || licenseNo.trim().length === 0 || this.partnerLicenseNo === licenseNo) {
      this.isInvalidLicense = false;
      return;
    }
    if (!licenseNo.match(this.onlyNumberPattern)) {
      this.isInvalidLicense = false;
      this.toaster.error('License No. already exists');
      return;
    }
    this.firmService.validateLicenseNo(licenseNo).subscribe(res => {
      if (res.status === 204) {
        this.isInvalidLicense = false;
      } else {
        this.isInvalidLicense = true;
        this.toaster.error('License No. already exists');
      }
    });
  }

  downloadPDF(role) {
    if (role === 'partner') {
      this.apiService.getFiles('Import Templates/pdf/Firm-Team.pdf').subscribe(res => {
        this.downloadPDFFile = res;
        if (this.downloadPDFFile) {
          window.open(this.downloadPDFFile, '_blank');
        }
      });
    } else if (role === 'client') {
      this.apiService.getFiles('Import Templates/pdf/Firm_Client.pdf').subscribe(res => {
        this.downloadPDFFile = res;
        if (this.downloadPDFFile) {
          window.open(this.downloadPDFFile, '_blank');
        }
      });
    }
  }

  //Step 3 client form
  loadClientForm() {
    this.clientDetailsForm = this.fb.group({
      'clientId': new UntypedFormControl(''),
      'legalEntityName': new UntypedFormControl('', [Validators.required]),
      'subentitysectionData': new UntypedFormControl(''),
      'typeOfEntity': new UntypedFormControl(),
      'incorporationDate': new UntypedFormControl(''),
      'groupName': new UntypedFormControl(),
      'clientFirstName': new UntypedFormControl(),
      'clientLastName': new UntypedFormControl(),
      'clientEmail': new UntypedFormControl('', [Validators.required, Validators.pattern(environment.EMAIL_REG_EXP)]),
      'clientCellPhone': new UntypedFormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
      'clientBusinessPhone': new UntypedFormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
      'clientAddress': new UntypedFormControl(),
      'clientCountry': new UntypedFormControl(),
      'clientState': new UntypedFormControl(),
      'clientCity': new UntypedFormControl(),
      'clientZipCode': new UntypedFormControl(),
      'engPartner': new UntypedFormControl('', [Validators.required]),
      'uniqueId': new UntypedFormControl('')
    });
    this.getTypeOfEntity();
    this.gettypeofsubentity();
  }

  // Original Email Validation
  validateStep3Email() {
    this.isInvalidEmail3 = true;
    let email = this.clientDetailsForm.get('clientEmail').value;
    if (this.clientEmail === email) {
      this.isInvalidEmail3 = false;
    } else {
      if (email && email.match(environment.EMAIL_REG_EXP)) {
        let invalidEmails = [];
        let invalidPartnerEmails = [];
        if (this.partnersGridData.filter(element => email === element.partnerEmail).length > 0) {
          this.toaster.error('Email Address already exists. Please use another email');
          this._emailEl.nativeElement.focus();
          this.isEmailError = true;
          return;
        }
        this.firmService.validateEmail(email, 4).subscribe(res => {
          if (res.status !== 200) {
            this.isInvalidEmail3 = true;
            this.toaster.error('Email Address already exists. Please use another email');
            this._emailEl.nativeElement.focus();
            this.isEmailError = true;
          } else {
            this.isInvalidEmail3 = false;
            this._emailEl.nativeElement.focus();
            this.isEmailError = false;
          }
        });
      }
    }
  }

  validateEmail() {
    setTimeout(() => {
      if (this.ClientEmail.invalid) {
        if (this.ClientEmail.errors.uniqueEmail) {
          this.toaster.error('Email Address already exists. Please use another email');
          return;
        }
      }
    }, 1000);
  }

  validateStep3Id() {
    let id = this.clientDetailsForm.get('clientId').value;
    if (this.clientId === id) {
      this.isInvalidId3 = false;
    } else {
      if (id && id.match(this.alphanumericDecimalPattern)) {
        let invalidIds = [];
        invalidIds = this.clientsGridData.filter(element => id === element.clientId);
        const inputData = {
          'validateid':
            [{
              'id': id,
              'validatestatus': 0
            }]
        };
        this.clientService.validateClientIds(JSON.stringify(inputData)).subscribe({
          next: response => {
            if (response.status === 200 && response.data) {
              const result = JSON.parse(response.data);
              if (result[0].validatestatus === 1 || invalidIds.length > 0) {
                this.isInvalidId3 = true;
                if (this.isInvalidId3 == true) {
                  this.toaster.error('Client Id already exists');
                }
              } else {
                this.isInvalidId3 = false;
              }
            }
          }
        });
      }
    }
  }

  getTypeOfEntity() {
    this.apiService.getTypeOfEntity().subscribe(data => {
      this.typeOfEntityDetails = data;
    });
  }

  gettypeofsubentity() {
    this.clientService.getTypeOfSubEntity().subscribe({
      next: res => {
        if (res) {
          const subtypeOfEntityDetails = JSON.parse(res);
          this.subtypeOfEntityDetails = subtypeOfEntityDetails.subentity;
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  getAccessType() {
    this.userApiService.getAllUserAccessType().subscribe({
      next: res => {
        let data = JSON.parse(res);
        this.accessType = data.Accesstype;
      }
    });
  }

  selectedAccessTypeMember(event) {
    this.selectedAccessType = {};
    this.selectedAccessType['useraccessname'] = event.useraccessname;
    this.selectedAccessType['useraccesstypeid'] = +event.useraccesstypeid;
  }

  switchTabs(event, val, type: 'step-2' | 'step-3') {
    if (this.disableTeam == true && type === 'step-2') {
      this.offSwitchTabs = true;
      return;
    }
    this.processType = val;
    if (type === 'step-2' && val === 'import') {
      if (this.partnerDetailsForm.controls['id'].value
        || this.partnerDetailsForm.controls['partnerFirstName'].value
        || this.partnerDetailsForm.controls['partnerLastName'].value
        || this.partnerDetailsForm.controls['partnerEmail'].value
        || this.partnerDetailsForm.controls['PartnerCellNo'].value
        || this.partnerDetailsForm.controls['hourlyRate'].value
        || this.partnerDetailsForm.controls['licenseNo'].value
        || this.partnerDetailsForm.controls['partnerBusinessPhone'].value
        || this.partnerDetailsForm.controls['role'].value
      ) {
        this.formType = type;
        event.preventDefault();
        this.dialog.open(this.alertDialog, {}).afterClosed().subscribe();
      }
    }
    if (type === 'step-3' && val === 'import') {
      if (
        this.clientDetailsForm.controls['clientCellPhone'].value
        || this.clientDetailsForm.controls['clientEmail'].value
        || this.clientDetailsForm.controls['clientFirstName'].value
        || this.clientDetailsForm.controls['clientLastName'].value
        || this.clientDetailsForm.controls['engPartner'].value
        || this.clientDetailsForm.controls['legalEntityName'].value
        || this.clientDetailsForm.controls['typeOfEntity'].value) {
        this.formType = type;
        event.preventDefault();
        this.dialog.open(this.alertDialog, {}).afterClosed().subscribe();
      }
    }
  }

  changeProcessType() {
    this.processType = 'manual';
  }

  resetForm(type) {
    if (type === 'step-2') {
      if (this.actualPartnersGridData.data) {
        this.actualPartnersGridData.data.forEach(e => e.isEditMode = false);
      }
      this.isInvalidId2 = false;
      this.isInvalidEmail2 = false;
      this.isInvalidName2 = false;
      this.isEditPartner = false;
      this.partnerDetailsForm.reset();
      let general = this.accessType.useraccesstypeid = 1;
      this.partnerDetailsForm.get('accessType').setValue(general);
    }
    if (type === 'step-3') {
      if (this.actualClientsGridData.data) {
        this.actualClientsGridData.data.forEach(e => e.isEditMode = false);
      }
      this.isInvalidId3 = false;
      this.isInvalidEmail3 = false;
      this.isEditClient = false;
      this.clientDetailsForm.reset();
    }
  }

  preventBackbutton(type) {
    if (type === 'step2back') {
      this.showStep1 = false;
      this.showStep2 = true;
      this.showStep3 = false;
      this.showStep4 = false;
      this.isCompletedStep1 = true;
    }
    if (type === 'step3back') {
      this.showStep1 = false;
      this.showStep2 = false;
      this.showStep3 = true;
      this.showStep4 = false;
      this.isCompletedStep1 = true;
      this.isCompletedStep2 = true;
    }
  }

  back(type) {
    this.backType = type;
    this.dialog.open(this.alertDialog1, {}).afterClosed().subscribe();
  }

  goBack(type, from) {
    if (from === 'step2back' && type === 'step-1') {
      this.isInvalidId2 = false;
      this.isInvalidEmail2 = false;
      this.isInvalidName2 = false;
      this.isEditPartner = false;
      this.showStep1 = true;
      this.showStep2 = false;
      this.showStep3 = false;
      this.showStep4 = false;
      if (this.actualPartnersGridData.data) {
        this.actualPartnersGridData.data.forEach(e => e.isEditMode = false);
      }
      this.partnerDetailsForm.reset();
      let general = this.accessType.useraccesstypeid = 1;
      this.partnerDetailsForm.get('accessType').setValue(general);
    }
    if (from === 'step3back' && type === 'step-1') {
      this.isInvalidId3 = false;
      this.isInvalidEmail3 = false;
      this.isEditClient = false;
      this.showStep1 = true;
      this.showStep2 = false;
      this.showStep3 = false;
      this.showStep4 = false;
      if (this.actualClientsGridData.data) {
        this.actualClientsGridData.data.forEach(e => e.isEditMode = false);
      }
      this.clientDetailsForm.reset();
    }
    if (from === 'step3back' && type === 'step-2') {
      this.isInvalidId3 = false;
      this.isInvalidEmail3 = false;
      this.isEditClient = false;
      this.showStep1 = false;
      this.showStep2 = true;
      this.showStep3 = false;
      this.showStep4 = false;
      if (this.actualClientsGridData.data) {
        this.actualClientsGridData.data.forEach(e => e.isEditMode = false);
      }
      this.clientDetailsForm.reset();
      this.stepper.previous();
    }
  }

  public handlePhone(event, type) {
    const onlyNums = event.target.value.replace(/[^0-9]/g, '');
    if (type == 'licenseNo' && onlyNums.length < 11) {
      this.partnerDetailsForm.controls['licenseNo'].setValue(onlyNums);
    }
    if (type == 'pLicenseNo' && onlyNums.length < 11) {
      this.firmSuperAdminForm.controls['pLicenseNo'].setValue(onlyNums);
    }
    if (type == 'czipCode' && onlyNums.length < 7) {
      this.clientDetailsForm.controls['clientZipCode'].setValue(onlyNums);
    }
    if (onlyNums.length < 10) {
      if (type == 'business') {
        this.firmSuperAdminForm.controls['businessPhone'].setValue(onlyNums);
      } else if (type == 'cell') {
        this.firmSuperAdminForm.controls['cellPhone'].setValue(onlyNums);
      } else if (type == 'pbnum') {
        this.partnerDetailsForm.controls['partnerBusinessPhone'].setValue(onlyNums);
      } else if (type == 'pcnum') {
        this.partnerDetailsForm.controls['PartnerCellNo'].setValue(onlyNums);
      } else if (type == 'clientbnum') {
        this.clientDetailsForm.controls['clientBusinessPhone'].setValue(onlyNums);
      } else if (type == 'clientcnum') {
        this.clientDetailsForm.controls['clientCellPhone'].setValue(onlyNums);
      } else {
        return;
      }
    } else if (onlyNums.length === 10) {
      const number = onlyNums.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      if (type == 'business') {
        this.firmSuperAdminForm.controls['businessPhone'].setValue(number);
      } else if (type == 'cell') {
        this.firmSuperAdminForm.controls['cellPhone'].setValue(number);
      } else if (type == 'pbnum') {
        this.partnerDetailsForm.controls['partnerBusinessPhone'].setValue(number);
      } else if (type == 'pcnum') {
        this.partnerDetailsForm.controls['PartnerCellNo'].setValue(number);
      } else if (type == 'clientbnum') {
        this.clientDetailsForm.controls['clientBusinessPhone'].setValue(number);
      } else if (type == 'clientcnum') {
        this.clientDetailsForm.controls['clientCellPhone'].setValue(number);
      } else {
        return;
      }
    }
  }

  public alphaNumeric(event, type: string) {
    const alphaNumeric = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
    const alphaNumericWithSpaces = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
    if (type === 'PEGID') {
      this.firmSuperAdminForm.controls['pegId'].setValue(alphaNumeric);
    } else if (type === 'MEMBERId') {
      this.partnerDetailsForm.controls['id'].setValue(alphaNumeric);
    } else if (type === 'pMemberId') {
      this.firmSuperAdminForm.controls['pMemberId'].setValue(alphaNumeric);
    } else if (type === 'CLIENTID') {
      this.clientDetailsForm.controls['clientId'].setValue(alphaNumericWithSpaces);
    } else if (type == 'zipcode') {
      this.firmSuperAdminForm.controls['zipCode'].setValue(alphaNumeric);
    } else if (type == 'czipCode') {
      this.clientDetailsForm.controls['clientZipCode'].setValue(alphaNumeric);
    } else if (type == 'pegLicenseNo') {
      this.firmSuperAdminForm.controls['pegLicenseNo'].setValue(alphaNumeric);
    }
  }

  // get countries list
  getCountriesList() {
    this.apiService.getCountries().subscribe(response => {
      this.countries = response;
    });
  }

  disable() {
    let general = this.accessType.useraccesstypeid = 1;
    setTimeout(() => {
      if (this.partnersGridData.length == 0 || this.partnersGridData.length == null) {
        this.partnerDetailsForm.get('accessType').disable();
        this.disableTeam = true;
        this.staffDisable = true;
        this.offSwitchTabs = false;
        this.isDisable = true;
      } else {
        this.partnerDetailsForm.get('accessType').enable();
        this.partnerDetailsForm.get('accessType').setValue(general);
        this.staffDisable = false;
      }
    }, 3000);
  }

  checkDates(value: string) {
    this.firmSuperAdminForm.controls['pegExpiryDate'].setValue(value);
    if (this.firmSuperAdminForm.controls['pegExpiryDate'].invalid) {
      this.toaster.error('Please enter valid date in MM/DD/YYYY format');
    }
  }

  /* Step one */
  goToStep2() {
    this.firmDetails = this.firmSuperAdminForm.value;
    if (this.user.origin_country_id == 226) {
      this.firmDetails.pegLicenseNo = '1111';
      this.firmDetails.pegId = 'Yes';
      this.firmDetails.pegExpiryDate = '2021-01-01';
    }
    if (this.firmSuperAdminForm.valid) {
      let firmData = {
        'emailid': this.firmDetails.email,
        'firmName': this.firmDetails.firmName,
        'pegsubscriber': this.firmDetails.pegId,
        'peglicencenumber': this.firmDetails.pegLicenseNo,
        'pegexpirydate': this.firmDetails.pegExpiryDate,
        'firstname': this.firmDetails.firstName,
        'lastname': this.firmDetails.lastName,
        'address': this.firmDetails.address,
        'bphone': this.firmDetails.businessPhone,
        'cellphone': this.firmDetails.cellPhone,
        'countryname': this.firmDetails.country,
        'statename': this.firmDetails.state,
        'cityname': this.firmDetails.city,
        'zipcode': this.firmDetails.zipCode,
        'pMemberId': this.firmDetails.pMemberId,
        'pLicenseNo': this.firmDetails.pLicenseNo,
        'pHourlyRate': this.firmDetails.pHourlyRate,
        'pTitle': this.firmDetails.pTitle,
        'pofficelocation': 'Canada',
        'loginid': this.useraccountId
      };
      let firmJsonObj = {'firmdetails': firmData};
      let firmJsonString = JSON.stringify(firmJsonObj);
      let partnerData = this.partnersList.map(partner => (
        {
          firstname: partner.partnerFirstName,
          lastname: partner.partnerLastName,
          emailAddress: partner.partnerEmail,
          licenseNo: partner.licenseNo,
          hourlyrate: partner.hourlyRate,
          businessNo: partner.partnerBusinessPhone,
          phoneNo: partner.PartnerCellNo,
          clientList: null,
          partnerUserAcctId: 0,
          loginid: this.useraccountId,
          designationId: 0,
          designationName: partner.title,
          memberid: partner.id,
          accessType: partner.accessType
        }
      ));
      let partnersJsonObj = {'partnersList': partnerData};
      let partnersJsonString = JSON.stringify(partnersJsonObj);
      this.clientsList.forEach(client => {
        client.incorporationDate = this.datePipe.transform(client.incorporationDate, 'yyyy-MM-dd');
        this.typeOfEntityDetails.forEach(item => {
          if (client.typeOfEntityName == item.typeofentityname) {
            client.typeofentityid = item.typeofentityid;
          }
        });
        this.subtypeOfEntityDetails.forEach(item => {
          if (client.subentityname == item.subentityname) {
            client.typeofsubentityid = item.typeofsubentityid;
          }
        });
        if (this.user.origin_country_id == 38) {
          client.subentityname = 'S - Corp';
          client.typeofsubentityid = 1;
        }
      });

      let clientData = this.clientsList.map(client => (
        {
          entityname: client.legalEntityName,
          pbphonenumber: client.clientBusinessPhone ? client.clientBusinessPhone : '',
          pcphonenumber: client.clientCellPhone ? client.clientCellPhone : '',
          pemailadd: client.clientEmail,
          ppwd: 'adinovis',
          firstname: client.clientFirstName ? client.clientFirstName : '',
          lastname: client.clientLastName ? client.clientLastName : '',
          entitytype: client.typeOfEntityName ? client.typeOfEntityName : '',
          subentityname: client.subentityname ? client.subentityname : '',
          typeofsubentityid: client.typeofsubentityid ? client.typeofsubentityid : '',
          pincorporationdate: client.incorporationDate ? client.incorporationDate : '',
          ploginid: this.useraccountId,
          pid: client.clientId ? client.clientId : '',
          groupName: client.groupName ? client.groupName : '',
          address: client.clientAddress,
          clientCountry: client.clientCountry ? client.clientCountry : '',
          clientState: client.clientState ? client.clientState : '',
          clientCity: client.clientCity ? client.clientCity : '',
          clientZipCode: client.clientZipCode,
          engPartnerEmail: client.engPartnerEmail ? client.engPartnerEmail : ''
        }
      ));
      let clientsJsonObj = {'clientsList': clientData};
      let clientsJsonString = JSON.stringify(clientsJsonObj);
      let partnersInvitesList = this.partnersList.filter((item) => {
        return item.isInvite;
      });
      let staffInviteList = this.staffList.filter((item) => {
        return item.isInvite == true;
      });
      let allInviteList = partnersInvitesList ? partnersInvitesList : null;
      if (staffInviteList && staffInviteList.length > 0) {
        allInviteList = partnersInvitesList.concat(staffInviteList);
      }
      let invitesData = allInviteList.map(item => (
        {
          email: item.partnerEmail
        }
      ));
      let invitesJsonObj = {'inviteList': invitesData};
      let invitesJsonString = JSON.stringify(invitesJsonObj);
      let staffJsonString = '';
      if (this.staffList && this.staffList.length > 0) {
        let staffData = this.staffList.map(staff => (
          {
            id: staff.id,
            firstName: staff.partnerFirstName,
            lastName: staff.partnerLastName,
            emailAddress: staff.partnerEmail,
            businessNo: staff.partnerBusinessPhone,
            phoneNo: staff.PartnerCellNo,
            licenseNo: staff.licenseNo,
            hourlyrate: staff.hourlyRate,
            clientList: null,
            designationId: 0,
            designationName: staff.title,
            firmStaffId: 0,
            staffuseraccountid: 0,
            firmPartnerId: 0,
            loginId: this.useraccountId,
            memberid: staff.id,
            accessType: staff.accessType
          }
        ));
        let staffJsonObj = {'staffList': staffData};
        staffJsonString = JSON.stringify(staffJsonObj);
      }

      let data = {
        'firmList': firmJsonString,
        'partnerList': partnersJsonString ? partnersJsonString : null,
        'clientList': clientsJsonString ? clientsJsonString : null,
        'assignedList': null,
        'inviteList': invitesJsonString ? invitesJsonString : null,
        'staffList': staffJsonString ? staffJsonString : null
      };
      this.apiService.saveFirmFourSteps(data).subscribe(() => {
        if (this.partnersGridData.length == 0) {
          let accessData = this.accessType.useraccesstypeid = 2;
          this.partnerDetailsForm.get('id').setValue(this.firmDetails.pMemberId);
          this.partnerDetailsForm.get('licenseNo').setValue(this.firmDetails.pLicenseNo);
          this.partnerDetailsForm.get('partnerFirstName').setValue(this.firmDetails.firstName);
          this.partnerDetailsForm.get('partnerLastName').setValue(this.firmDetails.lastName);
          this.partnerDetailsForm.get('partnerBusinessPhone').setValue(this.firmDetails.businessPhone);
          this.partnerDetailsForm.get('PartnerCellNo').setValue(this.firmDetails.cellPhone);
          this.partnerDetailsForm.get('partnerEmail').setValue(this.firmDetails.email);
          this.partnerDetailsForm.get('hourlyRate').setValue(this.firmDetails.pHourlyRate);
          this.partnerDetailsForm.get('title').setValue(this.firmDetails.pTitle);
          this.partnerDetailsForm.get('role').setValue('Partner');
          this.partnerDetailsForm.get('accessType').setValue(accessData);
          this.partnerDetailsForm.get('accessType').disable();
          this.disableTeam = true;
          this.staffDisable = true;
          this.offSwitchTabs = false;
          this.isDisable = false;
          this.addPartner();
          this.saveFirstPartner();
        } else {
          let accessData = this.accessType.useraccesstypeid = 2;
          this.partnerDetailsForm.patchValue({
            'id': this.firmDetails.pMemberId,
            'partnerFirstName': this.firmDetails.firstName,
            'partnerLastName': this.firmDetails.lastName,
            'partnerEmail': this.firmDetails.email,
            'title': this.firmDetails.pTitle,
            'partnerBusinessPhone': this.firmDetails.businessPhone,
            'PartnerCellNo': this.firmDetails.cellPhone,
            'licenseNo': this.firmDetails.pLicenseNo,
            'hourlyRate': this.firmDetails.pHourlyRate,
            'role': 'Partner',
            'accessType': accessData,
            'uniqueId': 1
          });
          let partnersData = this.partnerDetailsForm.value;
          this.partnersGridData.forEach(element => {
            if (partnersData.partnerEmail == element.partnerEmail) {
              this.onEditPartner();
            }
          });
        }
        this.showStep2 = true;
        this.processType = 'manual';
        this.showStep1 = false;
        this.showStep3 = false;
        this.showStep4 = false;
        this.isCompletedStep1 = true;
        this.isCitiesLoading2 = true;
        this.toaster.success('Firm details saved successfully');
      }, error => {
        this.toaster.error(error.error);
      });
    } else {
      if (!this.firmSuperAdminForm.valid) {
        this.showStep1 = true;
      }
    }
  }

  // Save FirstPartner()
  saveFirstPartner() {
    this.partnersList = this.partnersGridData.filter(p => p.role.toLowerCase() === 'partner');
    this.staffList = this.partnersGridData.filter(s => s.role.toLowerCase() === 'staff');
    this.firmDetails = this.firmSuperAdminForm.value;
    if (this.user.origin_country_id == 226) {
      this.firmDetails.pegLicenseNo = '1111';
      this.firmDetails.pegId = 'Yes';
      this.firmDetails.pegExpiryDate = '2021-01-01';
    }
    if (this.firmSuperAdminForm.valid) {
      let firmData = {
        'emailid': this.firmDetails.email,
        'firmName': this.firmDetails.firmName,
        'pegsubscriber': this.firmDetails.pegId,
        'peglicencenumber': this.firmDetails.pegLicenseNo,
        'pegexpirydate': this.firmDetails.pegExpiryDate,
        'firstname': this.firmDetails.firstName,
        'lastname': this.firmDetails.lastName,
        'address': this.firmDetails.address,
        'bphone': this.firmDetails.businessPhone,
        'cellphone': this.firmDetails.cellPhone,
        'countryname': this.firmDetails.country,
        'statename': this.firmDetails.state,
        'cityname': this.firmDetails.city,
        'zipcode': this.firmDetails.zipCode,
        'pMemberId': this.firmDetails.pMemberId,
        'pLicenseNo': this.firmDetails.pLicenseNo,
        'pHourlyRate': this.firmDetails.pHourlyRate,
        'pTitle': this.firmDetails.pTitle,
        'pofficelocation': 'Canada',
        'loginid': this.useraccountId
      };
      let firmJsonObj = {'firmdetails': firmData};
      let firmJsonString = JSON.stringify(firmJsonObj);
      let partnerData = this.partnersList.map(partner => (
        {
          firstname: partner.partnerFirstName,
          lastname: partner.partnerLastName,
          emailAddress: partner.partnerEmail,
          licenseNo: partner.licenseNo,
          hourlyrate: partner.hourlyRate,
          businessNo: partner.partnerBusinessPhone,
          phoneNo: partner.PartnerCellNo,
          clientList: null,
          partnerUserAcctId: 0,
          loginid: this.useraccountId,
          designationId: 0,
          designationName: partner.title,
          memberid: partner.id,
          accessType: partner.accessType
        }
      ));
      let partnersJsonObj = {'partnersList': partnerData};
      let partnersJsonString = JSON.stringify(partnersJsonObj);
      this.clientsList.forEach(client => {
        client.incorporationDate = this.datePipe.transform(client.incorporationDate, 'yyyy-MM-dd');
        this.typeOfEntityDetails.forEach(item => {
          if (client.typeOfEntityName == item.typeofentityname) {
            client.typeofentityid = item.typeofentityid;
          }
        });
        this.subtypeOfEntityDetails.forEach(item => {
          if (client.subentityname == item.subentityname) {
            client.typeofsubentityid = item.typeofsubentityid;
          }
        });
        if (this.user.origin_country_id == 38) {
          client.subentityname = 'S - Corp';
          client.typeofsubentityid = 1;
        }
      });

      let clientData = this.clientsList.map(client => (
        {
          entityname: client.legalEntityName,
          pbphonenumber: client.clientBusinessPhone ? client.clientBusinessPhone : '',
          pcphonenumber: client.clientCellPhone ? client.clientCellPhone : '',
          pemailadd: client.clientEmail,
          ppwd: 'adinovis',
          firstname: client.clientFirstName ? client.clientFirstName : '',
          lastname: client.clientLastName ? client.clientLastName : '',
          entitytype: client.typeOfEntityName ? client.typeOfEntityName : '',
          subentityname: client.subentityname ? client.subentityname : '',
          typeofsubentityid: client.typeofsubentityid ? client.typeofsubentityid : '',
          pincorporationdate: client.incorporationDate ? client.incorporationDate : '',
          ploginid: this.useraccountId,
          pid: client.clientId ? client.clientId : '',
          groupName: client.groupName ? client.groupName : '',
          address: client.clientAddress,
          clientCountry: client.clientCountry ? client.clientCountry : '',
          clientState: client.clientState ? client.clientState : '',
          clientCity: client.clientCity ? client.clientCity : '',
          clientZipCode: client.clientZipCode,
          engPartnerEmail: client.engPartnerEmail ? client.engPartnerEmail : ''
        }
      ));
      let clientsJsonObj = {'clientsList': clientData};
      let clientsJsonString = JSON.stringify(clientsJsonObj);
      let partnersInvitesList = this.partnersList.filter((item) => {
        return item.isInvite;
      });
      let staffInviteList = this.staffList.filter((item) => {
        return item.isInvite == true;
      });
      let allInviteList = partnersInvitesList ? partnersInvitesList : null;
      if (staffInviteList && staffInviteList.length > 0) {
        allInviteList = partnersInvitesList.concat(staffInviteList);
      }
      let invitesData = allInviteList.map(item => (
        {
          email: item.partnerEmail
        }
      ));
      let invitesJsonObj = {'inviteList': invitesData};
      let invitesJsonString = JSON.stringify(invitesJsonObj);
      let staffJsonString = '';
      if (this.staffList && this.staffList.length > 0) {
        let staffData = this.staffList.map(staff => (
          {
            id: staff.id,
            firstName: staff.partnerFirstName,
            lastName: staff.partnerLastName,
            emailAddress: staff.partnerEmail,
            businessNo: staff.partnerBusinessPhone,
            phoneNo: staff.PartnerCellNo,
            licenseNo: staff.licenseNo,
            hourlyrate: staff.hourlyRate,
            clientList: null,
            designationId: 0,
            designationName: staff.title,
            firmStaffId: 0,
            staffuseraccountid: 0,
            firmPartnerId: 0,
            loginId: this.useraccountId,
            memberid: staff.id,
            accessType: staff.accessType
          }
        ));
        let staffJsonObj = {'staffList': staffData};
        staffJsonString = JSON.stringify(staffJsonObj);
      }
      let data = {
        'firmList': firmJsonString,
        'partnerList': partnersJsonString ? partnersJsonString : null,
        'clientList': clientsJsonString ? clientsJsonString : null,
        'assignedList': null,
        'inviteList': invitesJsonString ? invitesJsonString : null,
        'staffList': staffJsonString ? staffJsonString : null
      };
      this.apiService.saveFirmFourSteps(data).subscribe(() => {
        this.showStep2 = true;
        this.processType = 'manual';
        this.showStep1 = false;
        this.showStep3 = false;
        this.showStep4 = false;
        this.isCompletedStep1 = true;
        this.isCitiesLoading2 = true;
        this.toaster.success('Firm details saved successfully');
      }, error => {
        this.toaster.error(error.error);
      });
    } else {
      if (!this.firmSuperAdminForm.valid) {
        this.showStep1 = true;
      }
    }
  }

  activeStep1() {
    if (this.clientDetailsForm.controls['clientAddress'].value
      || this.clientDetailsForm.controls['clientBusinessPhone'].value
      || this.clientDetailsForm.controls['clientCellPhone'].value
      || this.clientDetailsForm.controls['clientCity'].value
      || this.clientDetailsForm.controls['clientCountry'].value
      || this.clientDetailsForm.controls['clientEmail'].value
      || this.clientDetailsForm.controls['clientId'].value
      || this.clientDetailsForm.controls['clientState'].value
      || this.clientDetailsForm.controls['clientZipCode'].value
      || this.clientDetailsForm.controls['engPartner'].value
      || this.clientDetailsForm.controls['groupName'].value
      || this.clientDetailsForm.controls['incorporationDate'].value
      || this.clientDetailsForm.controls['legalEntityName'].value
      || this.clientDetailsForm.controls['typeOfEntity'].value) {
      this.fromBackType = 'step3back';
      this.backType = 'step-1';
      this.dialog.open(this.alertDialog1, {}).afterClosed().subscribe();
    } else if (this.partnerDetailsForm.controls['id'].value
      || this.partnerDetailsForm.controls['partnerFirstName'].value
      || this.partnerDetailsForm.controls['partnerLastName'].value
      || this.partnerDetailsForm.controls['partnerEmail'].value
      || this.partnerDetailsForm.controls['PartnerCellNo'].value
      || this.partnerDetailsForm.controls['hourlyRate'].value
      || this.partnerDetailsForm.controls['licenseNo'].value
      || this.partnerDetailsForm.controls['partnerBusinessPhone'].value
      || this.partnerDetailsForm.controls['role'].value
    ) {
      this.fromBackType = 'step2back';
      this.backType = 'step-1';
      this.dialog.open(this.alertDialog1, {}).afterClosed().subscribe();
    } else {
      this.showStep1 = true;
      this.showStep2 = false;
      this.showStep3 = false;
      this.showStep4 = false;
      this.isCompletedStep1 = true;
      this.stepper.previous();
    }
  }

  activeStep2() {
    if (this.clientDetailsForm.controls['clientAddress'].value
      || this.clientDetailsForm.controls['clientBusinessPhone'].value
      || this.clientDetailsForm.controls['clientCellPhone'].value
      || this.clientDetailsForm.controls['clientCity'].value
      || this.clientDetailsForm.controls['clientCountry'].value
      || this.clientDetailsForm.controls['clientEmail'].value
      || this.clientDetailsForm.controls['clientId'].value
      || this.clientDetailsForm.controls['clientState'].value
      || this.clientDetailsForm.controls['clientZipCode'].value
      || this.clientDetailsForm.controls['clientFirstName'].value
      || this.clientDetailsForm.controls['clientLastName'].value
      || this.clientDetailsForm.controls['engPartner'].value
      || this.clientDetailsForm.controls['groupName'].value
      || this.clientDetailsForm.controls['incorporationDate'].value
      || this.clientDetailsForm.controls['legalEntityName'].value
      || this.clientDetailsForm.controls['typeOfEntity'].value) {
      this.fromBackType = 'step3back';
      this.backType = 'step-2';
      this.changeProcessType();
      this.dialog.open(this.alertDialog1, {}).afterClosed().subscribe();
    } else {
      this.showStep1 = false;
      this.showStep2 = true;
      this.showStep3 = false;
      this.showStep4 = false;
      this.isCompletedStep1 = true;
      this.changeProcessType();
      this.validMark();
      this.stepper.previous();
    }
  }

  activeStep3() {
    this.showStep1 = false;
    this.showStep2 = false;
    this.showStep3 = true;
    this.showStep4 = false;
    this.isCompletedStep1 = true;
    this.changeProcessType();
    this.validMark();
  }

  validMark() {
    if (this.firmSuperAdminForm.get('firmName').value == '' || this.firmSuperAdminForm.get('address').value == '' ||
      this.firmSuperAdminForm.get('country').value == '' || this.firmSuperAdminForm.get('state').value == '' ||
      this.firmSuperAdminForm.get('city').value == '' || this.firmSuperAdminForm.get('zipCode').value == '' || this.firmSuperAdminForm.get('zipCode').value == undefined ||
      this.firmSuperAdminForm.get('firstName').value == '' || this.firmSuperAdminForm.get('lastName').value == '' ||
      this.firmSuperAdminForm.get('email').value == '') {
      this.isCompletedStep1 = false;
    }
  }

  // csv upload
  redirectToLogin() {
    this.router.navigate(['/login']);
  }

  // import data from csv
  uploadListener($event: any, type, from: 'step-2' | 'step-3'): void {
    let invalidLicenseList: any = [];
    let firstName = [];
    let lastName = [];
    let partnerEmail = [];
    let clientEmail = [];
    let memberId = [];
    let contactPersonName = [];
    let groupName = [];
    let legalEntityName = [];
    let clientId = [];
    let businessArray = [], cellArray = [];
    let partnerBusinessArray = [], partnerCellArray = [];
    // uploading manual
    const files = type == 'manual' ? $event.srcElement.files : $event; //for drag and drop file upload
    if (files && files.length > 1) {
      this.toaster.error('Upload one file at a time');
    } else {
      if (this.isValidCSVFile(files[0])) {
        const input = type == 'manual' ?
          $event.target.files[0] :
          files[0];
        let reader = new FileReader();
        reader.readAsText(input);
        reader.onload = () => {
          let teamList = [];
          let clientList = [];
          let csvData = reader.result;
          let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
          let headersRow = this.getHeaderArray(csvRecordsArray);
          if (csvRecordsArray.length > 1 && headersRow.length > 1) {
            if (from === 'step-2') {
              if (headersRow.length === 11) {
                if (JSON.stringify(headersRow) != JSON.stringify(this.partnerImportColumns1)) {
                  this.records = [];
                  this.toaster.error('Imported file has mismatched columns compared to template');
                } else {
                  this.records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
                  this.records.forEach(obj => {
                    if ((!obj.licenseNo.match(this.onlyNumberPattern) || obj.licenseNo.length > 11)) {
                      invalidLicenseList.push(obj.licenseNo);
                    }
                    if (obj.partnerFirstName.length > 100) {
                      firstName.push(obj.partnerFirstName);
                    }
                    if (obj.partnerLastName.length > 100) {
                      lastName.push(obj.partnerLastName);
                    }
                    if (obj.partnerEmail.length > 100) {
                      partnerEmail.push(obj.partnerEmail);
                    }
                    if (obj.partnerBusinessPhone && (obj.partnerBusinessPhone.length > 10 || obj.partnerBusinessPhone.length < 10)) {
                      partnerBusinessArray.push(obj.partnerBusinessPhone);
                    }
                    if (obj.PartnerCellNo && (obj.PartnerCellNo.length > 10 || obj.PartnerCellNo.length < 10)) {
                      partnerCellArray.push(obj.PartnerCellNo);
                    }
                    if (obj.id.length > 100) {
                      memberId.push(obj.id);
                    }
                    if (firstName.length === 0 || lastName.length === 0 || memberId.length === 0) {
                      if (invalidLicenseList.length === 0) {
                        if (obj['isAlphanumericId']) {
                          delete obj['isAlphanumericId'];
                        }
                        if (obj.id) {
                          if (!obj.id.match(this.alphanumericPattern)) {
                            obj['isAlphanumericId'] = 1;
                          } else {
                            obj['isAlphanumericId'] = 0;
                          }
                        }
                        if (obj.role && obj.role.toLowerCase() === 'partner') {
                          obj.isInvite = true;
                          this.addPartnerIndex = this.addPartnerIndex + 1;
                          obj.index = this.addPartnerIndex;
                          obj.processType = 'import'; //added extra key value to identify process type(import,manual) of
                          teamList.push(obj);
                        } else {
                          obj.isInvite = true;
                          this.addPartnerIndex = this.addPartnerIndex + 1;
                          obj.index = this.addPartnerIndex;
                          //added extra key value to identify process type(import,manual) of uploaded data or added
                          // data object (Abhay)
                          obj.processType = 'import';
                          teamList.push(obj);
                        }
                      }
                    }
                  });
                  if (firstName.length > 0 || lastName.length > 0 || memberId.length > 0 || partnerEmail.length > 0) {
                    this.toaster.error('First | Last Name| Member ID | Email: Max allowed 100 charecters!');
                  } else if (invalidLicenseList.length > 0) {
                    this.toaster.error('Invalid License No | Max allowed 11 numbers');
                  } else if (partnerBusinessArray.length > 0 && partnerCellArray.length > 0) {
                    this.toaster.error('Invalid Business | Cell Phone: Allowed 10 digits');
                  } else if (partnerBusinessArray.length > 0) {
                    this.toaster.error('Invalid Business Phone: Allowed 10 digits!');
                  } else if (partnerCellArray.length > 0) {
                    this.toaster.error('Invalid Cell Phone: Allowed 10 digits!');
                  } else if (teamList.length > 0) {
                    this.bindPartnersImportGrid(teamList.filter((ele) => ele.partnerEmail !== ''));
                  } else {
                    this.toaster.error('Provided csv file is empty!');
                  }
                }
              } else {
                this.toaster.error('Duplicate data identified in Step 2. Please check and update');
              }
            } else if (from === 'step-3') {
              if (this.user.origin_country_id == 226) {
                if (headersRow.length === 19) {
                  if (JSON.stringify(headersRow) != JSON.stringify(this.USAclientImportColumns)) {
                    this.records = [];
                    this.toaster.error('Imported file has mismatched columns compared to template');
                  } else {
                    this.records = this.getDataRecordsArrayFromCSVFile2(csvRecordsArray, headersRow.length);
                    this.records.forEach(obj => {
                      if (obj.groupName.length > 100) {
                        groupName.push(obj.groupName);
                      }
                      if (obj.legalEntityName.length > 100) {
                        legalEntityName.push(obj.legalEntityName);
                      }
                      if (obj.clientId.length > 100) {
                        clientId.push(obj.clientId);
                      }
                      if (obj.clientEmail.length > 100) {
                        clientEmail.push(obj.clientEmail);
                      }
                      if (obj.clientBusinessPhone && (obj.clientBusinessPhone.length > 10 || obj.clientBusinessPhone.length < 10)) {
                        businessArray.push(obj.clientBusinessPhone);
                      }
                      if (obj.clientCellPhone && (obj.clientCellPhone.length > 10 || obj.clientCellPhone.length < 10)) {
                        cellArray.push(obj.clientCellPhone);
                      }
                      if (obj['isAlphanumericId']) {
                        delete obj['isAlphanumericId'];
                      }
                      if (obj.clientId) {
                        if (!obj.clientId.match(this.alphanumericDecimalPattern)) {
                          obj['isAlphanumericId'] = 1;
                        } else {
                          obj['isAlphanumericId'] = 0;
                        }
                      }
                      if (obj.incorporationDate == 'Invalid Date' || obj.incorporationDate == 'null' || obj.incorporationDate == undefined) {
                        obj.incorporationDate = null;
                      }
                      obj.role = obj.role.toLowerCase();
                      this.addClientIndex = this.addClientIndex + 1;
                      obj.index = this.addClientIndex;
                      obj.processType = 'import'; //added extra key value to identify process type(import,manual) of
                      // uploaded data or added data object (Abhay)
                      clientList.push(obj);
                    });
                    if (legalEntityName.length > 0 || contactPersonName.length > 0 || clientId.length > 0 || groupName.length > 0 || clientEmail.length > 0) {
                      this.toaster.error('Legal Entity Name | Contact Person Name | Group Name | Client ID | Email: Max allowed 100 charecters');
                    } else if (businessArray.length > 0 && cellArray.length > 0) {
                      this.toaster.error('Invalid Business | Cell Phone: Allowed 10 digits');
                    } else if (businessArray.length > 0) {
                      this.toaster.error('Invalid Business Phone: Allowed 10 digits');
                    } else if (cellArray.length > 0) {
                      this.toaster.error('Invalid Cell Phone: Allowed 10 digits');
                    } else if (clientList.length > 0) {
                      var clientListResult = clientList.filter((ele) => ele.clientEmail !== '');
                      this.bindClientsImportGrid(clientListResult);
                    } else {
                      this.toaster.error('Provided csv file is empty!');
                    }
                  }
                } else {
                  this.toaster.error('All required columns are not present in the file. Please compare with the given template and re-import.');
                }
              } else if (this.user.origin_country_id == 38) {
                if (headersRow.length === 17) {
                  if (JSON.stringify(headersRow) != JSON.stringify(this.clientImportColumns1)) {
                    this.records = [];
                    this.toaster.error('Imported file has mismatched columns compared to template');
                  } else {
                    this.records = this.getDataRecordsArrayFromCSVFile1(csvRecordsArray, headersRow.length);
                    this.records.forEach(obj => {
                      if (obj.groupName.length > 100) {
                        groupName.push(obj.groupName);
                      }
                      if (obj.legalEntityName.length > 100) {
                        legalEntityName.push(obj.legalEntityName);
                      }
                      if (obj.clientId.length > 100) {
                        clientId.push(obj.clientId);
                      }
                      if (obj.clientEmail.length > 100) {
                        clientEmail.push(obj.clientEmail);
                      }
                      if (obj.clientBusinessPhone && (obj.clientBusinessPhone.length > 10 || obj.clientBusinessPhone.length < 10)) {
                        businessArray.push(obj.clientBusinessPhone);
                      }
                      if (obj.clientCellPhone && (obj.clientCellPhone.length > 10 || obj.clientCellPhone.length < 10)) {
                        cellArray.push(obj.clientCellPhone);
                      }
                      if (obj['isAlphanumericId']) {
                        delete obj['isAlphanumericId'];
                      }
                      if (obj.clientId) {
                        if (!obj.clientId.match(this.alphanumericDecimalPattern)) {
                          obj['isAlphanumericId'] = 1;
                        } else {
                          obj['isAlphanumericId'] = 0;
                        }
                      }
                      if (obj.incorporationDate == 'Invalid Date' || obj.incorporationDate == 'null' || obj.incorporationDate == undefined) {
                        obj.incorporationDate = null;
                      }
                      obj.role = obj.role.toLowerCase();
                      this.addClientIndex = this.addClientIndex + 1;
                      obj.index = this.addClientIndex;
                      obj.processType = 'import'; //added extra key value to identify process type(import,manual) of
                      // uploaded data or added data object (Abhay)
                      clientList.push(obj);
                    });
                    if (legalEntityName.length > 0 || contactPersonName.length > 0 || clientId.length > 0 || groupName.length > 0 || clientEmail.length > 0) {
                      this.toaster.error('Legal Entity Name | Contact Person Name | Group Name | Client ID | Email: Max allowed 100 charecters');
                    } else if (businessArray.length > 0 && cellArray.length > 0) {
                      this.toaster.error('Invalid Business | Cell Phone: Allowed 10 digits');
                    } else if (businessArray.length > 0) {
                      this.toaster.error('Invalid Business Phone: Allowed 10 digits');
                    } else if (cellArray.length > 0) {
                      this.toaster.error('Invalid Cell Phone: Allowed 10 digits');
                    } else if (clientList.length > 0) {
                      this.bindClientsImportGrid(clientList.filter((ele) => ele.clientEmail !== ''));
                    } else {
                      this.toaster.error('Provided csv file is empty!');
                    }
                  }
                } else {
                  this.toaster.error('All required columns are not present in the file. Please compare with the given template and re-import.');
                }
              }
            }
          } else {
            this.toaster.error('Provided .CSV file is empty');
          }
        };
        reader.onerror = function () {
          console.log('error is occurred while reading file!');
        };
      } else {
        this.toaster.error('Please import valid .csv file');
        this.fileReset();
      }
    }
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];
    for (let i = 1; i < csvRecordsArray.length; i++) {
      const currentRecord = csvRecordsArray[i].split(',');
      if (currentRecord.length == headerLength) {
        let csvRecord: any = {};
        // partner client
        csvRecord.role = this.sharedService.toTitleCase(currentRecord[9].trim());
        csvRecord.title = currentRecord[0].trim();
        csvRecord.id = currentRecord[1].trim();
        csvRecord.partnerFirstName = currentRecord[2].trim();
        csvRecord.partnerLastName = currentRecord[3].trim();
        csvRecord.fullName = currentRecord[2].trim() + '' + currentRecord[3].trim();
        csvRecord.partnerEmail = currentRecord[4].trim().toLowerCase();
        csvRecord.partnerBusinessPhone = currentRecord[5].trim();
        csvRecord.PartnerCellNo = currentRecord[6].trim();
        csvRecord.licenseNo = currentRecord[7].trim();
        let hr = currentRecord[8] ? currentRecord[8].trim() : '';
        csvRecord.hourlyRate = hr % 1 == 0 ? hr + '.00' : hr;
        csvRecord.accessType = currentRecord[10].trim().toLowerCase() == 'sup' ?
          'Super Admin' :
          currentRecord[10].trim().toLowerCase() == 'adm' ?
            'Admin' :
            currentRecord[10].trim().toLowerCase() == 'gen' ?
              'General' :
              currentRecord[10].trim().toLowerCase() == 'lim' ?
                'Limited' :
                this.sharedService.toTitleCase(currentRecord[10].trim());
        csvRecord.isAssignedPartner = currentRecord[0].trim().toLowerCase() === 'partner' ? false : '';
        csvRecord.isSelectedPartner = currentRecord[0].trim().toLowerCase() === 'partner' ? false : '';
        csvRecord.isInvite = true;
        csvArr.push(csvRecord);
      }
    }
    try {
      if (this.csvReader) {
        this.csvReader.nativeElement.value = '';
      }
    } catch (e) { }
    return csvArr;
  }

  getDataRecordsArrayFromCSVFile1(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];
    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = csvRecordsArray[i].split(',');
      if (curruntRecord.length === headerLength) {
        let csvRecord: any = {};
        //partnerclient
        csvRecord.clientId = curruntRecord[0].trim().toLowerCase();
        csvRecord.legalEntityName = curruntRecord[1].trim();
        let typeOfEntity = curruntRecord[2].trim();
        this.typeOfEntityDetails.filter(e => {
          if (e.typeofentityname === typeOfEntity) {
            typeOfEntity = e.typeofentityid;
          }
        });
        csvRecord.typeOfEntity = typeOfEntity;
        let date = curruntRecord[3].trim().toLowerCase();
        date = new Date(date);
        csvRecord.incorporationDate = date;
        csvRecord.groupName = curruntRecord[16].trim();
        csvRecord.fullName = curruntRecord[4].trim() + ' ' + curruntRecord[5].trim();
        csvRecord.clientFirstName = curruntRecord[4].trim();
        csvRecord.clientLastName = curruntRecord[5].trim();
        csvRecord.clientEmail = curruntRecord[6].trim().toLowerCase();
        csvRecord.clientBusinessPhone = curruntRecord[7].trim();
        csvRecord.clientCellPhone = curruntRecord[8].trim();
        csvRecord.clientAddress = curruntRecord[9].trim();
        csvRecord.clientCountry = curruntRecord[12].trim();
        csvRecord.clientState = curruntRecord[11].trim();
        csvRecord.clientCity = curruntRecord[10].trim();
        csvRecord.clientZipCode = curruntRecord[13].trim();
        let engPartnerName: any;
        let engPartnerEmail: any;
        engPartnerName = curruntRecord[14].trim();
        engPartnerEmail = curruntRecord[15].trim()?.toLowerCase();
        const partner = curruntRecord[14].trim();
        const partnerEmail = curruntRecord[15].trim()?.toLowerCase();
        this.partnersGridData.filter(e => {
          if (e.partnerEmail === partnerEmail && e.fullName === partner) {
            engPartnerName = partner;
            engPartnerEmail = partnerEmail;
          }
        });
        csvRecord.engPartnerName = engPartnerName ? engPartnerName : '';
        csvRecord.engPartnerEmail = engPartnerEmail ? engPartnerEmail : '';
        csvRecord.typeOfEntityName = curruntRecord[2].trim();
        csvRecord.role = 'client';
        csvArr.push(csvRecord);
      }
    }
    try {
      if (this.csvReader) {
        this.csvReader.nativeElement.value = '';
      }
    } catch (e) { }
    return csvArr;
  }

  getDataRecordsArrayFromCSVFile2(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];
    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = csvRecordsArray[i].split(',');
      if (curruntRecord.length === headerLength) {
        let csvRecord: any = {};
        // partnerclient
        csvRecord.clientId = curruntRecord[0].trim().toLowerCase();
        csvRecord.legalEntityName = curruntRecord[1].trim();
        let typeOfEntity = curruntRecord[2].trim();
        this.typeOfEntityDetails.filter(e => {
          if (e.typeofentityname === typeOfEntity) {
            typeOfEntity = e.typeofentityid;
          }
        });
        csvRecord.typeOfEntity = typeOfEntity;
        let subentitytypeid = curruntRecord[3].trim();
        this.subtypeOfEntityDetails.filter(e => {
          if (e.subentityname == subentitytypeid) {
            subentitytypeid = e.typeofsubentityid;
          }
        });
        csvRecord.typeofsubentityid = subentitytypeid;
        let date = curruntRecord[4].trim().toLowerCase();
        date = new Date(date);
        csvRecord.incorporationDate = date;
        csvRecord.groupName = curruntRecord[18].trim();
        csvRecord.fullName = curruntRecord[5].trim() + ' ' + curruntRecord[6].trim();
        csvRecord.clientFirstName = curruntRecord[5].trim();
        csvRecord.clientLastName = curruntRecord[6].trim();
        csvRecord.clientEmail = curruntRecord[7].trim().toLowerCase();
        csvRecord.clientBusinessPhone = curruntRecord[8].trim();
        csvRecord.clientCellPhone = curruntRecord[9].trim();
        csvRecord.clientAddress = curruntRecord[11].trim();
        csvRecord.clientCountry = curruntRecord[14].trim();
        csvRecord.clientState = curruntRecord[13].trim();
        csvRecord.clientCity = curruntRecord[12].trim();
        csvRecord.clientZipCode = curruntRecord[15].trim();
        let engPartnerName = curruntRecord[16].trim();
        let engPartnerEmail = curruntRecord[17].trim()?.toLowerCase();
        const partner = curruntRecord[16].trim();
        const partnerEmail = curruntRecord[17].trim()?.toLowerCase();
        this.partnersGridData.filter(e => {
          if (e.partnerEmail === partnerEmail && e.fullName === partner) {
            engPartnerName = partner;
            engPartnerEmail = partnerEmail;
          }
        });
        csvRecord.engPartnerName = engPartnerName ? engPartnerName : '';
        csvRecord.engPartnerEmail = engPartnerEmail ? engPartnerEmail : '';
        csvRecord.typeOfEntityName = curruntRecord[2].trim();
        csvRecord.subentityname = curruntRecord[3].trim();
        csvRecord.role = 'client';
        csvArr.push(csvRecord);
      }
    }
    try {
      if (this.csvReader) {
        this.csvReader.nativeElement.value = '';
      }
    } catch (e) { }
    return csvArr;
  }

  isValidCSVFile(file: any) {
    return file.name.endsWith('.csv');
  }

  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  fileReset() {
    this.csvReader.nativeElement.value = '';
    this.records = [];
  }

  // add partner
  addPartner() {
    if (!this.partnerDetailsForm.valid) {
      return;
    }

    // let accData = this.partnerDetailsForm.get('accessType').setValue(accessData);
    // let accData = accessData
    let partnerDetailsObj = this.partnerDetailsForm.value;
    if (partnerDetailsObj.role === 9) {
      partnerDetailsObj.role = 'Partner';
    } else if (partnerDetailsObj.role === 3) {
      partnerDetailsObj.role = 'Staff';
    }

    this.addPartnerIndex = this.addPartnerIndex + 1;
    partnerDetailsObj.index = this.addPartnerIndex;
    partnerDetailsObj.isInvite = true;
    partnerDetailsObj.fullName = partnerDetailsObj.partnerFirstName + ' ' + partnerDetailsObj.partnerLastName;
    partnerDetailsObj.partnerEmail = partnerDetailsObj.partnerEmail.toLowerCase();
    let superAdmin = this.accessType.useraccesstypeid = 2;
    let general = this.accessType.useraccesstypeid = 1;
    if (this.partnersGridData.length == 0) {
      partnerDetailsObj.accessType = superAdmin;
    } else if (partnerDetailsObj.accessType === 1) {
      partnerDetailsObj.accessType = 'General';
    } else if (partnerDetailsObj.accessType === 2) {
      partnerDetailsObj.accessType = 'Super Admin';
    } else if (partnerDetailsObj.accessType === 3) {
      partnerDetailsObj.accessType = 'Admin';
    } else if (partnerDetailsObj.accessType === 4) {
      partnerDetailsObj.accessType = 'Limited';
    } else {
      partnerDetailsObj.accessType = general;
    }
    if (partnerDetailsObj.hourlyRate == 'NaN' || partnerDetailsObj.hourlyRate == null) {
      partnerDetailsObj.hourlyRate = '';
    }
    // uploaded data or added data object (Abhay)
    let teamList = [];
    if (partnerDetailsObj.role === 'Staff') {
      teamList.unshift(partnerDetailsObj);
    } else {
      partnerDetailsObj.isSelectedPartner = false;
      partnerDetailsObj.isAssignedPartner = false;
      teamList.unshift(partnerDetailsObj);
    }
    if (partnerDetailsObj.accessType === 1) {
      partnerDetailsObj.accessType = 'General';
    } else if (partnerDetailsObj.accessType === 2) {
      partnerDetailsObj.accessType = 'Super Admin';
    } else if (partnerDetailsObj.accessType === 3) {
      partnerDetailsObj.accessType = 'Admin';
    } else if (partnerDetailsObj.accessType === 4) {
      partnerDetailsObj.accessType = 'Limited';
    }
    this.bindPartnersGrid(partnerDetailsObj);
    this.partnerDetailsForm.reset();
    if (this.partnersGridData.length == 0) {
      this.partnerDetailsForm.get('accessType').disable();
    } else {
      this.partnerDetailsForm.get('accessType').enable();
    }
  }

  removeErr() {
    this.isEntityError = false;
  }

  validateClientNameEntity() {
    this.isInvalidClientName = true;
    let clientEntityName = this.clientDetailsForm.get('legalEntityName').value;
    let clientEmail = this.clientDetailsForm.get('clientEmail').value;
    if (clientEntityName) {
      let invalidClientEntityName = [];
      invalidClientEntityName = this.clientsGridData.filter(element =>
        (clientEntityName.toLowerCase() === element.legalEntityName.toLowerCase()) && (clientEmail === element.clientEmail)
      );
      let clientDetailsObj = this.clientDetailsForm.value;

      this.clientService.validateClientEntityName(clientDetailsObj.legalEntityName, clientDetailsObj.clientEmail).subscribe({
        next: res => {
          const result = JSON.parse(res);
          if (result[0].validatestatus === 1 || invalidClientEntityName.length > 0) {
            this.isInvalidClientName = true;
            if (this.isInvalidClientName == true) {
              this.toaster.error('Entity name already exists');
              this._entityEl.nativeElement.focus();
              this.isEntityError = true;
            }
          } else {
            this.isInvalidClientName = false;
            this._entityEl.nativeElement.focus();
            this.isEntityError = false;
            this.addClient();
          }
        }
      });
    }
  }

  addClient() {
    if (!this.clientDetailsForm.valid) {
      return;
    }
    let clientDetailsObj = this.clientDetailsForm.value;
    this.addClientIndex = this.addClientIndex + 1;
    clientDetailsObj.index = this.addClientIndex;
    clientDetailsObj.clientEmail = clientDetailsObj.clientEmail.toLowerCase();
    clientDetailsObj.fullName = clientDetailsObj.clientFirstName + ' ' + clientDetailsObj.clientLastName;
    this.typeOfEntityDetails.forEach(item => {
      if (item.typeofentityid == clientDetailsObj.typeOfEntity) {
        clientDetailsObj.typeOfEntityName = item.typeofentityname;
      }
    });
    this.subtypeOfEntityDetails.forEach(item => {
      if (item.typeofsubentityid == clientDetailsObj.subentitysectionData) {
        clientDetailsObj.subentityname = item.subentityname;
      }
    });
    if (this.user.origin_country_id == 38) {
      clientDetailsObj.subentityname = 'S - Corp';
      clientDetailsObj.typeofsubentityid = 1;
    }
    let engPartner = clientDetailsObj.engPartner ? clientDetailsObj.engPartner : '';
    let engPartnerName, engParnerEmail;
    if (engPartner) {
      this.partnersList.map(e => {
        if (e.fullName === engPartner) {
          engPartnerName = e.fullName;
          engParnerEmail = e.partnerEmail;
        }
      });
      clientDetailsObj.engPartnerName = engPartnerName;
      clientDetailsObj.engPartnerEmail = engParnerEmail;
    } else {
      clientDetailsObj.engPartnerName = '';
      clientDetailsObj.engPartnerEmail = '';
    }
    clientDetailsObj.role = 'client';
    this.bindClientsGrid(clientDetailsObj);
    if (this.clientDetailsForm.valid) {
      setTimeout(() =>
        this.clientDetailsForm.reset(), 0);
    }
  }

  bindPartnersGrid(list) {
    this.partnersGridData.push(list);
    if (this.partnersGridData.length > 0) {
      this.disableTeam = false;
      this.staffDisable = false;
      this.offSwitchTabs = true;
      this.partnerDetailsForm.get('accessType').enable();
    }
    this.onUniqueIdCheck();
    this.onUniqueLicenseNo1();
    this.onLoadEmailCheck();
    this.onPhoneNumberCheck('partnerGrid');
  }

  bindClientsGrid(list) {
    this.clientsGridData.push(list);
    this.onClientUniqueIdCheck();
    this.onClientEmailCheck();
    this.onPhoneNumberCheck('clientGrid');
  }

  bindPartnersImportGrid(list) {
    this.partnersImportGridData = list;
    this.onUniqueLicenseNo();
    this.onUniqueIdCheck1();
    this.onLoadEmailCheck1('IMPORT');
    this.onPhoneNumberCheck('partnerImportGrid');
  }

  bindClientsImportGrid(list) {
    this.clientsImportGridData = list;
    this.onClientUniqueIdCheck1();
    this.onClientEmailEntityCheck1();
    this.onClientEmailCheck1('IMPORT');
    this.onPhoneNumberCheck('clientImportGrid');
  }

  onPartnersGridLoad(list) {
    let invalidEmails = list.filter(e => e.emailValidationStatus === 1 || e.emailValidationStatus === 2 || e.emailValidationStatus === 3);
    this.partnerEmailStatus = invalidEmails.length > 0;
    let invalidIds = list.filter(e => e.duplicateIDStatus === 1 || e.duplicateIDStatus === 2 || e.duplicateIDStatus === 3);
    this.partnerIdStatus = invalidIds.length > 0;
    let invalidNames = list.filter(e => e.nameValidationStatus === 1 || e.nameValidationStatus === 2 || e.nameValidationStatus === 3);
    this.partnerNameStatus = invalidNames.length > 0;
    let invalidLicenseNo = list.filter(e => e.duplicateLicenseNoStatus === 1 || e.duplicateLicenseNoStatus === 2 || e.duplicateLicenseNoStatus === 3);
    this.partnerLicenseNostatus = invalidLicenseNo.length > 0;
    this.actualPartnersGridData = [];
    this.actualPartnersGridData = new MatTableDataSource(list);
  }

  onClientsGridLoad(list) {
    let invalidEmails = list.filter(e => e.emailValidationStatus === 1 || e.emailValidationStatus === 2 || e.emailValidationStatus === 3);
    this.clientEmailStatus = invalidEmails.length > 0;
    let invalidIds = list.filter(e => e.duplicateIDStatus === 1 || e.duplicateIDStatus === 2 || e.duplicateIDStatus === 3);
    this.clientIdStatus = invalidIds.length > 0;
    this.actualClientsGridData = [];
    this.actualClientsGridData = new MatTableDataSource(list);
    this.actualClientsGridData.data.forEach(element => {
      if (element.index) {
        element['isChecked'] = false;
      }
    });
  }

  // licenseNo:any;
  onPartnersImportGridLoad(list, type: 'DELETE' | 'IMPORT') {
    this.errorMessage = '';
    this.RequirefieldValidation = false;
    let invalidEmails = list.filter(e => e.emailValidationStatus === 1 || e.emailValidationStatus === 2 || e.emailValidationStatus === 3);
    if (invalidEmails.length > 0) {
      this.partnerImportEmailStatus = true;
      this.errorMessage = 'Email';
    } else {
      this.partnerImportEmailStatus = false;
    }
    let invalidIds = list.filter(e => e.duplicateIDStatus === 1 || e.duplicateIDStatus === 2 || e.duplicateIDStatus === 3 || e.isAlphanumericId);
    if (invalidIds.length > 0) {
      this.partnerImportIdStatus = true;
      this.errorMessage = 'Member ID';
    } else {
      this.partnerImportIdStatus = false;
    }
    let invalidLicenseNo = list.filter(e => e.duplicateLicenseNoStatus === 1 || e.duplicateLicenseNoStatus === 2 || e.duplicateLicenseNoStatus === 3);
    if (invalidLicenseNo.length > 0) {
      this.partnerImportLicenseStatus = true;
      this.errorMessage = 'License No';
    } else {
      this.partnerImportLicenseStatus = false;
    }
    if (invalidLicenseNo.length > 0 && invalidEmails.length > 0) {
      this.partnerImportLicenseStatus = true;
      this.partnerImportEmailStatus = true;
      this.errorMessage = 'Email & License No';
    }
    if (invalidEmails.length > 0 && invalidIds.length > 0) {
      this.partnerImportEmailStatus = true;
      this.partnerImportIdStatus = true;
      this.errorMessage = 'Member ID & Email';
    }
    if (invalidLicenseNo.length > 0 && invalidIds.length > 0) {
      this.partnerImportLicenseStatus = true;
      this.partnerImportIdStatus = true;
      this.errorMessage = 'Member ID & License No';
    }
    if (invalidLicenseNo.length > 0 && invalidIds.length > 0 && invalidEmails.length > 0) {
      this.partnerImportEmailStatus = true;
      this.partnerImportIdStatus = true;
      this.partnerImportLicenseStatus = true;
      this.errorMessage = 'Member ID & Email & License No';
    }
    let fullnameValidation = list.filter(e => e.fullName.length === 0 || e.fullName === '');
    if (fullnameValidation.length > 0) {
      this.RequirefieldValidation = true;
      this.errorMessage = 'Name';
    }
    let EmailValidation = list.filter(e => e.partnerEmail.length === 0 || e.partnerEmail === '');
    if (EmailValidation.length > 0) {
      this.RequirefieldValidation = true;
      this.partnerImportEmailStatus = false;
      this.errorMessage = 'Email';
    }
    let categoryValidation = list.filter(e => e.role.length === 0 || e.role === '');
    if (categoryValidation.length > 0) {
      this.RequirefieldValidation = true;
      this.errorMessage = 'Category';
    }
    let accessTypeValidation = list.filter(e => e.accessType.length === 0 || e.accessType === '');
    if (accessTypeValidation.length > 0) {
      this.RequirefieldValidation = true;
      this.errorMessage = 'Access Type';
    }
    this.actualPartnersImportGridData = [];
    this.actualPartnersImportGridData = new MatTableDataSource(list);
    if (type === 'IMPORT') {
      this.dialog.open(this.cnfUploadCsv, {
        disableClose: true,
        panelClass: 'upload-container'
      }).afterClosed().subscribe();
    }
  }

  onClientsImportGridLoad(list, type: 'DELETE' | 'IMPORT') {
    let invalidEmails = list.filter(e => e.emailValidationStatus === 1 || e.emailValidationStatus === 2 || e.emailValidationStatus === 3);
    if (invalidEmails.length > 0) {
      this.clientImportEmailStatus = true;
      this.clientErrMessage = 'Email';
    } else {
      this.clientImportEmailStatus = false;
    }
    let invalidIds = list.filter(e => e.duplicateIDStatus === 1 || e.duplicateIDStatus === 2 || e.duplicateIDStatus === 3 || e.isAlphanumericId);
    if (invalidIds.length > 0) {
      this.clientImportIdStatus = true;
      this.clientErrMessage = 'Client ID';
    } else {
      this.clientImportIdStatus = false;
    }
    let invalidEntityName = list.filter(e => e.duplicateEmailEntityStatus === 1 || e.duplicateEmailEntityStatus === 2 || e.duplicateEmailEntityStatus === 3);
    if (invalidEntityName.length > 0) {
      this.clientImportEntityStatus = true;
      this.clientErrMessage = 'Entity name';
    } else {
      this.clientImportEntityStatus = false;
    }
    // clientImportEntityStatus
    if (invalidIds.length > 0 && invalidEmails.length > 0) {
      this.clientImportEmailStatus = true;
      this.clientImportIdStatus = true;
      this.clientErrMessage = 'Client ID/Email';
    }
    if (invalidIds.length > 0 && invalidEntityName.length > 0) {
      this.clientImportEntityStatus = true;
      this.clientImportIdStatus = true;
      this.clientErrMessage = 'Client ID/Entity name';
    }
    if (invalidEmails.length > 0 && invalidEntityName.length > 0) {
      this.clientImportEmailStatus = true;
      this.clientImportEntityStatus = true;
      this.clientErrMessage = 'Email/Entity name';
    }
    if (invalidIds.length > 0 && invalidEmails.length > 0 && invalidEntityName.length > 0) {
      this.clientImportEmailStatus = true;
      this.clientImportEntityStatus = true;
      this.clientImportIdStatus = true;
      this.clientErrMessage = 'Client ID/Email/Entity name';
    }
    this.actualClientsImportGridData = [];
    this.actualClientsImportGridData = new MatTableDataSource(list);
    if (type === 'IMPORT') {
      this.dialog.open(this.cnfUploadCsvCli, {
        disableClose: true,
        panelClass: 'upload-container'
      }).afterClosed().subscribe();
    }
  }

  clearImportPartnersData() {
    this.actualPartnersImportGridData = [];
    this.partnersImportGridData = [];
    this.dialog.closeAll();
  }

  clearImportClientsData() {
    this.actualClientsImportGridData = [];
    this.clientsImportGridData = [];
    this.dialog.closeAll();
  }

  combineWithPartners() {
    this.partnersGridData = [...this.partnersGridData, ...this.partnersImportGridData];
    this.onUniqueIdCheck();
    this.onUniqueLicenseNo1();
    this.onLoadEmailCheck();
    this.onPhoneNumberCheck('partnerGrid');
    this.uploadSuccess = false;
    this.processType = 'manual';
    this.dialog.closeAll();
  }

  combineWithClients() {
    this.clientsGridData = [...this.clientsGridData, ...this.clientsImportGridData];
    this.onClientUniqueIdCheck();
    this.onClientEmailCheck();
    this.onPhoneNumberCheck('clientGrid');
    this.uploadSuccess = false;
    this.processType = 'manual';
    this.clientsList = this.clientsGridData.filter(c => c.role === 'client');
    this.dialog.closeAll();
  }

  editPartner(element) {
    this.isEditPartner = true;
    this.isInvalidId2 = false;
    this.isInvalidEmail2 = false;
    this.isInvalidName2 = false;
    let general = this.accessType.useraccesstypeid = 1;
    this.partnerId = element.id;
    this.partnerEmail = element.partnerEmail;
    this.partnerFullName = element.partnerFirstName.toLowerCase() + ' ' + element.partnerLastName.toLowerCase();
    this.processType = 'manual';
    element.isEditMode = true;
    let team: any;
    if (element.role === 'Staff') {
      team = 3;
    } else {
      team = 9;
    }
    let accType: any;
    if (element.accessType.toLowerCase() === 'general') {
      accType = 1;
    } else if (element.accessType.toLowerCase() === 'super admin') {
      accType = 2;
      this.isReadonly = true;
    } else if (element.accessType.toLowerCase() === 'admin') {
      accType = 3;
    } else if (element.accessType.toLowerCase() === 'limited') {
      accType = 4;
    }
    if (element.index === 1) {
      this.staffDisable = true;
      this.partnerDetailsForm.get('accessType').disable();
    } else {
      this.partnerDetailsForm.get('accessType').enable();
      this.partnerDetailsForm.get('accessType').setValue(general);
    }
    this.partnerDetailsForm.patchValue({
      'id': element.id == '-' ? element.id.replace('-', '') : element.id,
      'partnerFirstName': element.partnerFirstName,
      'partnerLastName': element.partnerLastName,
      'partnerEmail': element.partnerEmail,
      'title': element.title,
      'partnerBusinessPhone': element.partnerBusinessPhone == '-' ? element.partnerBusinessPhone.replace('-', '') : element.partnerBusinessPhone,
      'PartnerCellNo': element.PartnerCellNo,
      'licenseNo': element.licenseNo == '-' ? element.licenseNo.replace('-', '') : element.licenseNo,
      'hourlyRate': element.hourlyRate == '-' || element.hourlyRate == '0.00' ? element.hourlyRate = '' : element.hourlyRate,
      'role': team,
      'accessType': accType,
      'uniqueId': element.index
    });
  }

  editClient(element) {
    this.isEditClient = true;
    this.isInvalidId3 = false;
    this.isInvalidEmail3 = false;
    this.clientId = element.clientId;
    this.clientEmail = element.clientEmail;
    this.legalEntityName = element.legalEntityName;
    this.processType = 'manual';
    element.isEditMode = true;
    this.engPartner = element.engPartnerName;
    this.partnersList.map(e => {
      e.isSelectedPartner = e.fullName === element.engPartnerName;
    });
    if (element.typeOfEntityName == 'corporation' || element.typeOfEntityName == 'Corporation') {
      element.typeOfEntity = 1;
    } else if (element.typeOfEntityName == 'partnership' || element.typeOfEntityName == 'Partnership') {
      element.typeOfEntity = 2;
    } else if (element.typeOfEntityName == 'sole proprietor' || element.typeOfEntityName == 'Sole Proprietor') {
      element.typeOfEntity = 3;
    } else if (element.typeOfEntityName == 'trust' || element.typeOfEntityName == 'Trust') {
      element.typeOfEntity = 4;
    }
    if (element.subentityname == 'S - Corp') {
      element.typeofsubentityid = 1;
    } else if (element.subentityname == 'C - Corp') {
      element.typeofsubentityid = 2;
    } else if (element.subentityname == 'LLC - Limited Liability') {
      element.typeofsubentityid = 3;
    }
    element.incorporationDate = moment(element.incorporationDate).toDate();
    if (element.incorporationDate == null || element.incorporationDate == 'Invalid Date' || element.incorporationDate == undefined) {
      element.incorporationDate = '';
    }
    this.clientDetailsForm.patchValue({
      'clientId': element.clientId,
      'legalEntityName': element.legalEntityName,
      'typeOfEntity': element.typeOfEntity,
      'subentitysectionData': element.typeofsubentityid,
      'incorporationDate': element.incorporationDate,
      'groupName': element.groupName,
      'clientEmail': element.clientEmail,
      'clientFirstName': element.clientFirstName,
      'clientLastName': element.clientLastName,
      'clientCellPhone': element.clientCellPhone,
      'clientBusinessPhone': element.clientBusinessPhone,
      'clientAddress': element.clientAddress,
      'clientCountry': element.clientCountry,
      'clientState': element.clientState,
      'clientCity': element.clientCity,
      'clientZipCode': element.clientZipCode,
      'engPartner': element.engPartnerName,
      'uniqueId': element.index
    });
  }

  cancel() {
    this.partnerDetailsForm.reset();
    this.isInvalidLicense = false;
    this.isReadonly = false;
    let general = this.accessType.useraccesstypeid = 1;
    if (this.partnersGridData.length == 0) {
      this.partnerDetailsForm.get('accessType').setValue(general);
      this.partnerDetailsForm.get('accessType').disable();
    } else {
      this.partnerDetailsForm.get('accessType').enable();
      this.partnerDetailsForm.get('accessType').setValue(general);
    }
    this.isEditPartner = false;
    this.staffDisable = false;
    this.partnersGridData.map(element => {
      element['isEditMode'] = false;
    });
  }

  onEditPartner() {
    if (!this.partnerDetailsForm.valid) {
      return;
    }
    this.isEditPartner = false;
    this.isInvalidId2 = false;
    this.isInvalidEmail2 = false;
    this.isInvalidName2 = false;
    let general = this.accessType.useraccesstypeid = 1;
    let obj = this.partnerDetailsForm.value;
    if (obj.role === 9) {
      obj.role = 'Partner';
    } else if (obj.role === 3) {
      obj.role = 'Staff';
    }
    this.staffDisable = false;
    if (obj.hourlyRate == 'NaN' || obj.hourlyRate == null) {
      obj.hourlyRate = '';
    }
    obj.isInvite = true;
    obj.fullName = obj.partnerFirstName + ' ' + obj.partnerLastName;
    let index = this.partnersGridData.findIndex(x => x.index === obj.uniqueId);
    obj.index = obj.uniqueId;
    if (this.partnersGridData.length == 0) {
      obj.accessType = 'Super Admin';
    } else if (obj.index === 1) {
      obj.accessType = 'Super Admin';
      this.firmSuperAdminForm.patchValue({
        'pMemberId': obj.id,
        'firstname': obj.partnerFirstName,
        'lastname': obj.partnerLastName,
        'emailid': obj.partnerEmail,
        'pTitle': obj.title,
        'businessPhone': obj.partnerBusinessPhone,
        'cellphone': obj.PartnerCellNo,
        'pLicenseNo': obj.licenseNo,
        'pHourlyRate': obj.hourlyRate,
        'role': obj.role
      });
    } else if (obj.accessType === 2) {
      obj.accessType = 'Super Admin';
    } else if (obj.accessType === 3) {
      obj.accessType = 'Admin';
    } else if (obj.accessType === 4) {
      obj.accessType = 'Limited';
    } else {
      obj.accessType = 'General';
    }
    if (index !== -1) {
      this.partnersGridData[index] = obj;
      this.partnersList[index] = obj;
      this.partnerId = '';
      this.partnerEmail = '';
      this.partnerFullName = '';
      this.onUniqueIdCheck();
      this.onUniqueLicenseNo1();
      this.onLoadEmailCheck();
    }
    this.partnerDetailsForm.reset();
    this.isReadonly = false;
    if (this.partnersGridData.length == 0) {
      this.partnerDetailsForm.get('accessType').disable();
    } else {
      this.partnerDetailsForm.get('accessType').enable();
      this.partnerDetailsForm.get('accessType').setValue(general);
    }
    if (obj.role.toLowerCase() === 'partner') {
      this.toaster.success('Partner details updated successfully');
      this.onUniqueIdCheck();
      this.onUniqueLicenseNo1();
      this.onLoadEmailCheck();
    } else if (obj.role.toLowerCase() === 'staff') {
      this.toaster.success('Staff details updated successfully');
      this.onUniqueIdCheck();
      this.onUniqueLicenseNo1();
      this.onLoadEmailCheck();
    }
  }

  onEditClientNameEntity() {
    this.isInvalidClientName = true;
    let clientEntityName = this.clientDetailsForm.get('legalEntityName').value;
    let clientEmail = this.clientDetailsForm.get('clientEmail').value;
    let uniqueId = this.clientDetailsForm.get('uniqueId').value;
    if (clientEntityName) {
      let invalidClientEntityName = [];
      invalidClientEntityName = this.clientsGridData.filter(element =>
        ((clientEntityName.toLowerCase() === element.legalEntityName.toLowerCase()) && (clientEmail === element.clientEmail)) && (uniqueId !== element.index)
      );
      this.clientDetailsObj = this.clientDetailsForm.value;
      this.clientService.validateClientEntityName(this.clientDetailsObj.legalEntityName, this.clientDetailsObj.clientEmail).subscribe({
        next: res => {
          const result = JSON.parse(res);
          if (result[0].validatestatus === 1 || invalidClientEntityName.length > 0) {
            this.isInvalidClientName = true;
            this.toaster.error('Entity name already exists');
          } else {
            this.isInvalidClientName = false;
            this.onEditClient(this.clientDetailsObj);
          }
        }
      });
    }
  }

  onEditClient(clientDetailsObj) {
    if (!this.clientDetailsForm.valid) {
      return;
    }
    this.isEditClient = false;
    this.isInvalidEmail3 = false;
    this.isInvalidId3 = false;
    let obj = clientDetailsObj;
    let engPartner = obj.engPartner ? obj.engPartner : '';
    let engPartnerName, engParnerEmail;
    if (engPartner) {
      this.partnersList.map(e => {
        if (e.fullName === engPartner) {
          engPartnerName = e.fullName;
          engParnerEmail = e.partnerEmail;
        }
      });
      obj.engPartnerName = engPartnerName;
      obj.engPartnerEmail = engParnerEmail;
    } else {
      obj.engPartnerName = '';
      obj.engPartnerEmail = '';
    }
    obj.fullName = obj.clientFirstName + ' ' + obj.clientLastName;
    let index = this.clientsGridData.findIndex(x => x.index === obj.uniqueId);
    obj.index = obj.uniqueId;
    this.typeOfEntityDetails.forEach(item => {
      if (item.typeofentityid == obj.typeOfEntity) {
        obj.typeOfEntityName = item.typeofentityname;
      }
    });
    this.subtypeOfEntityDetails.forEach(item => {
      if (item.typeofsubentityid == obj.subentitysectionData) {
        obj.subentityname = item.subentityname;
      }
    });
    if (this.user.origin_country_id == 38) {
      obj.subentityname = 'S - Corp';
      obj.typeofsubentityid = 1;
    }
    if (index !== -1) {
      this.clientsGridData[index] = obj;
      this.clientId = '';
      this.clientEmail = '';
      this.onClientEmailCheck();
      this.onClientUniqueIdCheck();
    } else {
      this.onClientUniqueIdCheck();
      this.onClientEmailCheck();
    }
    this.isEditClient = false;
    this.partnersList.map(e => e.isSelectedPartner = false);
    if (this.clientDetailsForm.valid) {
      setTimeout(() =>
        this.clientDetailsForm.reset(), 0);
    }
    this.toaster.success('Client details updated successfully');
  }

  step3Cancel() {
    if (this.clientDetailsForm.valid) {
      // To reset Form
      setTimeout(() =>
        this.formGroupDirective.resetForm(), 0);
    }
    this.isEditClient = false;
    this.actualClientsGridData.data.map(element => {
      element['isEditMode'] = false;
    });
  }

  deleteDialog(element): void {
    this.teamMemberData = element;
    if (this.teamMemberData.index === 1) {
      this.toaster.warning('Super admin record can not be deleted');
      return;
    }
    if (this.teamMemberData.role.toLowerCase() === 'partner') {
      this.confirmMessage = 'You are trying to delete partner.';
    } else if (this.teamMemberData.role.toLowerCase() === 'staff') {
      this.confirmMessage = 'You are trying to delete staff.';
    }
    this.dialog.open(this.deleteActionDialog, {disableClose: true}).afterClosed().subscribe();
  }

  onEditDelete() {
    let element = this.teamMemberData;
    if (element.index === 1) {
      this.toaster.warning('Super admin record can not be deleted');
      return;
    }
    this.partnersGridData = this.partnersGridData.filter(partnerId => partnerId.index !== element.index);
    if (element.role.toLowerCase() === 'partner') {
      this.toaster.success('Partner record deleted successfully');
    } else if (element.role.toLowerCase() === 'staff') {
      this.toaster.success('Staff record deleted successfully');
    }
    this.onUniqueIdCheck();
    this.onLoadEmailCheck();
    this.onUniqueLicenseNo1();
    this.partnersGridData.filter(fpartner => {
      this.actualClientsGridData.data.map(e => {
        if (fpartner.index !== element.index && element.partnerEmail === e.engPartnerEmail) {
          e['engPartnerEmail'] = '';
          e['engPartnerName'] = '';
        }
      });
    });
    if (this.partnersGridData.length === 0) {
      this.uploadSuccess = false;
      this.onPartnersGridLoad(this.partnersGridData);
    }
  }

  deleteClient() {
    let element = this.delClient;
    this.clientsGridData = this.clientsGridData.filter(x => x.index !== element.index);
    this.toaster.success('Client record deleted successfully');
    this.onClientUniqueIdCheck();
    this.onClientEmailCheck();
    if (this.clientsGridData.length === 0) {
      this.uploadSuccess = false;
      this.onClientsGridLoad(this.clientsGridData);
    }
  }

  openDeleteCli(element) {
    this.delClient = element;
    this.dialog.open(this.deleteActionClientDialog, {disableClose: true}).afterClosed().subscribe();
  }

  onDeleteImportedData(element) {
    this.partnersImportGridData = this.partnersImportGridData.filter(partnerId => partnerId.index !== element.index);
    if (element.role.toLowerCase() === 'partner') {
      this.toaster.success('Partner record deleted successfully');
    } else if (element.role.toLowerCase() === 'staff') {
      this.toaster.success('Staff record deleted successfully');
    }
    this.onUniqueLicenseNo();
    this.onUniqueIdCheck1();
    this.onLoadEmailCheck1('DELETE');
    if (this.partnersImportGridData.length === 0) {
      this.uploadSuccess = false;
      this.onPartnersImportGridLoad(this.partnersImportGridData, 'DELETE');
      this.dialog.closeAll();
    }
  }

  onDeleteImportedClientData(element) {
    this.clientsImportGridData = this.clientsImportGridData.filter(x => x.index !== element.index);
    this.toaster.success('Client record deleted successfully');
    this.onClientUniqueIdCheck1();
    this.onClientEmailCheck1('DELETE');
    if (this.clientsImportGridData.length === 0) {
      this.uploadSuccess = false;
      this.clientImportEmailStatus = false;
      this.onClientsImportGridLoad(this.clientsImportGridData, 'DELETE');
      this.dialog.closeAll();
    }
  }

  onLoadEmailCheck1(type: 'DELETE' | 'IMPORT') {
    this.partnersImportGridData.forEach(element => {
      if (element['emailValidationStatus']) {
        delete element['emailValidationStatus'];
      }
    });
    let tempList = this.partnersImportGridData;
    tempList.forEach(tempElement => {
      let count = 0;
      this.partnersImportGridData.forEach(element => {
        if (!element.partnerEmail.match(environment.EMAIL_REG_EXP) || element.partnerEmail === '') {
          element['emailValidationStatus'] = 3;
        }
        if (tempElement.partnerEmail === element.partnerEmail) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['emailValidationStatus'] = 2;
          }
        }
        this.clientsGridData.forEach(clientElement => {
          if (element.partnerEmail === clientElement.clientEmail) {
            element['emailValidationStatus'] = 2;
          }
        });
      });
    });
    const importDatalength: number = this.partnersImportGridData.length;
    this.processImportGridData(importDatalength, 0, type);
  }

  processImportGridData(importDatalength, index: any, type: any) {
    if (index < importDatalength) {
      this.partnersGridData.forEach(ele => {
        if (this.partnersImportGridData[index].partnerEmail === ele.partnerEmail) {
          this.partnersImportGridData[index]['emailValidationStatus'] = 2;
        }
        this.clientsGridData.forEach(clientElement => {
          if (this.partnersImportGridData[index].partnerEmail === clientElement.clientEmail) {
            this.partnersImportGridData[index]['emailValidationStatus'] = 2;
          }
        });
      });
      this.firmService.validateEmail(this.partnersImportGridData[index].partnerEmail).subscribe({
        next: res => {
          if (this.partnersImportGridData[index]['emailValidationStatus'] === 2 || this.partnersImportGridData[index]['emailValidationStatus'] === 3) {
            this.partnersImportGridData[index]['emailValidationStatus'] = this.partnersImportGridData[index]['emailValidationStatus'];
          } else {
            this.partnersImportGridData[index]['emailValidationStatus'] = (res.status === 200) ? 0 : 1;
          }
          this.partnersImportGridData[index]['isEditMode'] = false;
          index++;
          this.processImportGridData(importDatalength, index, type);
        },
        error: () => {
          index++;
          this.processImportGridData(importDatalength, index, type);
        }
      });
    } else {
      this.onPartnersImportGridLoad(this.partnersImportGridData, type);
    }
  }

  onLoadEmailCheck() {
    this.partnersGridData.forEach(element => {
      if (element['emailValidationStatus']) {
        delete element['emailValidationStatus'];
      }
    });
    let tempList = this.partnersGridData;
    tempList.forEach(tempElement => {
      let count = 0;
      this.partnersGridData.forEach(element => {
        if (!element.partnerEmail.match(environment.EMAIL_REG_EXP) || element.partnerEmail === '') {
          element['emailValidationStatus'] = 3;
        }
        if (tempElement.partnerEmail === element.partnerEmail) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['emailValidationStatus'] = 2;
          }
        }
      });
    });
    this.partnersGridData.forEach(element => {
      if (element.partnerEmail === this.user.emailAddress) {
        this.onPartnersGridLoad(this.partnersGridData);
        return;
      }
      this.firmService.validateEmail(element.partnerEmail).subscribe(res => {
        if (element['emailValidationStatus'] === 2 || element['emailValidationStatus'] === 3) {
          element['emailValidationStatus'] = element['emailValidationStatus'];
        } else {
          element['emailValidationStatus'] = (res.status === 200) ? 0 : 1;
        }
        element['isEditMode'] = false;
        this.onPartnersGridLoad(this.partnersGridData);
      });
    });
  }

  onUniqueIdCheck() {
    let tempList: any;
    this.partnersGridData.forEach(element => {
      if (element['duplicateIDStatus']) {
        delete element['duplicateIDStatus'];
      }
    });
    tempList = this.partnersGridData;
    tempList.forEach(tempElement => {
      let count = 0;
      this.partnersGridData.forEach(element => {
        if (tempElement.id === element.id && element.id) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateIDStatus'] = 2;
          }
        }
      });
    });
    this.partnersGridData.forEach(element => {
      if (element.id && element.id.trim().length > 0) {
        this.firmService.validateMemberId(element.id).subscribe(res => {
          if (element['duplicateIDStatus'] === 2 || element['duplicateIDStatus'] === 3) {
            element['duplicateIDStatus'] = element['duplicateIDStatus'];
          } else {
            element['duplicateIDStatus'] = res.status === 204 ? 0 : 1;
          }
          element['isEditMode'] = false;
        });
      }
    });
  }

  onUniqueLicenseNo1() {
    this.partnersGridData.forEach(element => {
      if (element['duplicateLicenseNoStatus']) {
        delete element['duplicateLicenseNoStatus'];
      }
    });
    this.partnersGridData.forEach(tempElement => {
      let count = 0;
      this.partnersGridData.forEach(element => {
        if (tempElement.licenseNo === element.licenseNo && element.licenseNo) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateLicenseNoStatus'] = 2;
          }
        }
      });
    });
    this.partnersGridData.forEach(element => {
      if (element.licenseNo && element.licenseNo.trim().length > 0) {
        this.firmService.validateLicenseNo(element.licenseNo).subscribe(res => {
          if (element['duplicateLicenseNoStatus'] === 2 || element['duplicateLicenseNoStatus'] === 3) {
            element['duplicateLicenseNoStatus'] = element['duplicateLicenseNoStatus'];
          } else {
            element['duplicateLicenseNoStatus'] = res.status === 204 ? 0 : 1;
          }
          element['isEditMode'] = false;
        });
      }
    });
  }

  onUniqueIdCheck1() {
    this.partnersImportGridData.forEach(element => {
      if (element['duplicateIDStatus']) {
        delete element['duplicateIDStatus'];
      }
    });
    this.partnersImportGridData.forEach(tempElement => {
      let count = 0;
      this.partnersImportGridData.forEach(element => {
        this.partnersGridData.forEach(gridData => {
          if (gridData.id === element.id && (gridData.id != '' && element.id != '')) {
            element['duplicateIDStatus'] = 3;
          }
        });
        if (tempElement.id === element.id && element.id) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateIDStatus'] = 2;
          }
        }
      });
    });
    this.partnersImportGridData.forEach(element => {
      if (element.id && element.id.trim().length > 0) {
        this.firmService.validateMemberId(element.id).subscribe(res => {
          if (element['duplicateIDStatus'] === 2 || element['duplicateIDStatus'] === 3) {
            element['duplicateIDStatus'] = element['duplicateIDStatus'];
          } else {
            element['duplicateIDStatus'] = res.status === 204 ? 0 : 1;
          }
          element['isEditMode'] = false;
        });
      }
    });
  }

  onUniqueLicenseNo() {
    this.partnersImportGridData.forEach(element => {
      if (element['duplicateLicenseNoStatus']) {
        delete element['duplicateLicenseNoStatus'];
      }
    });
    this.partnersImportGridData.forEach(tempElement => {
      let count = 0;
      this.partnersImportGridData.forEach(element => {
        this.partnersGridData.forEach(gridData => {
          if (gridData.licenseNo === element.licenseNo && (gridData.licenseNo != '' && element.licenseNo != '')) {
            element['duplicateLicenseNoStatus'] = 3;
          }
        });
        if (tempElement.licenseNo === element.licenseNo && element.licenseNo) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateLicenseNoStatus'] = 2;
          }
        }
      });
    });
    this.partnersImportGridData.forEach(element => {
      if (element.licenseNo && element.licenseNo.trim().length > 0) {
        this.firmService.validateLicenseNo(element.licenseNo).subscribe(res => {
          if (element['duplicateLicenseNoStatus'] === 2 || element['duplicateLicenseNoStatus'] === 3) {
            element['duplicateLicenseNoStatus'] = element['duplicateLicenseNoStatus'];
          } else {
            element['duplicateLicenseNoStatus'] = res.status === 204 ? 0 : 1;
          }
          element['isEditMode'] = false;
        });
      }
    });
  }

  onClientUniqueIdCheck() {
    this.clientsGridData.forEach(element => {
      if (element['duplicateIDStatus']) {
        delete element['duplicateIDStatus'];
      }
    });
    this.clientsGridData.forEach(tempElement => {
      let count = 0;
      this.clientsGridData.forEach(element => {
        if (tempElement.clientId === element.clientId && element.clientId) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateIDStatus'] = 2;
          }
        }
      });
    });
    this.clientIdsValidate();
  }

  onClientUniqueIdCheck1() {
    this.clientsImportGridData.forEach(element => {
      if (element['duplicateIDStatus']) {
        delete element['duplicateIDStatus'];
      }
    });
    this.clientsImportGridData.forEach(tempElement => {
      let count = 0;
      this.clientsImportGridData.forEach(element => {
        this.clientsGridData.forEach(gridData => {
          if (gridData.clientId === element.clientId && (gridData.clientId != '' && element.clientId != '')) {
            element['duplicateIDStatus'] = 3;
          }
        });
        if (tempElement.clientId === element.clientId && element.clientId) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateIDStatus'] = 2;
          }
        }
      });
    });
    this.clientIdsValidate();
  }

  onClientEmailEntityCheck1() {
    this.clientsImportGridData.forEach(element => {
      if (element['duplicateEmailEntityStatus']) {
        delete element['duplicateEmailEntityStatus'];
      }
    });
    this.clientsImportGridData.forEach(tempElement => {
      let count = 0;
      this.clientsImportGridData.forEach(element => {
        this.clientsGridData.forEach(gridData => {
          if (gridData.legalEntityName === element.legalEntityName && (gridData.legalEntityName != '' && element.legalEntityName != '') && (gridData.clientEmail === element.clientEmail)) {
            element['duplicateEmailEntityStatus'] = 3;
          }
        });
        if ((tempElement.legalEntityName === element.legalEntityName && element.legalEntityName) && tempElement.clientEmail === element.clientEmail) {
          if (count < 1) {
            count = count + 1;
          } else {
            count = count + 1;
            element['duplicateEmailEntityStatus'] = 2;
          }
        }
      });
    });
    this.clientsImportGridData.forEach(element => {
      this.clientService.validateClientEntityName(element.legalEntityName, element.clientEmail).subscribe({
        next: res => {
          if (res) {
            const result = JSON.parse(res);
            if (element['duplicateEmailEntityStatus'] === 2 || element['duplicateEmailEntityStatus'] === 3) {
              element['duplicateEmailEntityStatus'] = element['duplicateEmailEntityStatus'];
            } else {
              element['duplicateEmailEntityStatus'] = result[0].validatestatus;
            }
            element['isEditMode'] = false;
          }
        }
      });
    });
  }

  onClientEmailCheck() {
    this.clientsGridData.forEach(element => {
      if (element['emailValidationStatus']) {
        delete element['emailValidationStatus'];
      }
    });
    let tempList = this.clientsGridData;
    tempList.forEach(() => {
      this.clientsGridData.forEach(element => {
        if (!element.clientEmail.match(environment.EMAIL_REG_EXP) || element.clientEmail === '') {
          element['emailValidationStatus'] = 3;
        }
      });
    });
    this.partnersGridData.forEach(partnerEmail => {
      this.clientsGridData.forEach(element => {
        if (partnerEmail.partnerEmail === element.clientEmail) {
          element['emailValidationStatus'] = 2;
        }
      });
    });
    this.clientsGridData.forEach(element => {
      this.firmService.validateEmail(element.clientEmail, 4).subscribe(res => {
        if (element['emailValidationStatus'] === 2 || element['emailValidationStatus'] === 3) {
          element['emailValidationStatus'] = element['emailValidationStatus'];
        } else {
          element['emailValidationStatus'] = (res.status === 200) ? 0 : 1;
        }
        this.onClientsGridLoad(this.clientsGridData);
      });
    });
  }

  onClientEmailCheck1(type: 'DELETE' | 'IMPORT') {
    this.clientsImportGridData.forEach(element => {
      if (element['emailValidationStatus']) {
        delete element['emailValidationStatus'];
      }
    });
    let tempList = this.clientsImportGridData;
    tempList.forEach(() => {
      this.clientsImportGridData.forEach(element => {
        if (!element.clientEmail.match(environment.EMAIL_REG_EXP) || element.clientEmail === '') {
          element['emailValidationStatus'] = 3;
        }
        this.partnersGridData.forEach(partnerElement => {
          if (element.clientEmail === partnerElement.partnerEmail) {
            element['emailValidationStatus'] = 2;
          }
        });
      });
    });
    const importDatalength: number = this.clientsImportGridData.length;
    this.processImportClientGridData(importDatalength, 0, type);
  }

  //--------------------- original modified method -------------------------
  processImportClientGridData(importDatalength, index: any, type: any) {
    if (index < importDatalength) {
      this.clientsGridData.forEach(() => {
        this.partnersGridData.forEach(partnerElement => {
          if (this.clientsImportGridData[index].clientEmail === partnerElement.partnerEmail) {
            this.clientsImportGridData[index]['emailValidationStatus'] = 2;
          }
        });
      });
      this.firmService.validateEmail(this.clientsImportGridData[index].clientEmail, 4).subscribe(res => {
        if (this.clientsImportGridData[index]['emailValidationStatus'] === 2 || this.clientsImportGridData[index]['emailValidationStatus'] === 3) {
          this.clientsImportGridData[index]['emailValidationStatus'] = this.clientsImportGridData[index]['emailValidationStatus'];
        } else {
          this.clientsImportGridData[index]['emailValidationStatus'] = (res.status === 200) ? 0 : 1;
        }
        index++;
        this.processImportClientGridData(importDatalength, index, type);
      });
    } else {
      this.onClientsImportGridLoad(this.clientsImportGridData, type);
    }
  }

  onPhoneNumberCheck(type: 'partnerGrid' | 'clientGrid' | 'partnerImportGrid' | 'clientImportGrid') {
    if (type === 'partnerGrid') {
      this.partnersGridData.forEach(element => {
        if (element.partnerBusinessPhone) {
          const num = element.partnerBusinessPhone.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['partnerBusinessPhone'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
        if (element.PartnerCellNo) {
          const num = element.PartnerCellNo.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['PartnerCellNo'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
      });
    } else if (type === 'partnerImportGrid') {
      this.partnersImportGridData.forEach(element => {
        if (element.partnerBusinessPhone) {
          const num = element.partnerBusinessPhone.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['partnerBusinessPhone'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
        if (element.PartnerCellNo) {
          const num = element.PartnerCellNo.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['PartnerCellNo'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
      });
    } else if (type === 'clientGrid') {
      this.clientsList.forEach(element => {
        if (element.clientBusinessPhone) {
          const num = element.clientBusinessPhone.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['clientBusinessPhone'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
        if (element.clientCellPhone) {
          const num = element.clientCellPhone.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['clientCellPhone'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
      });
    } else if (type === 'clientImportGrid') {
      this.clientsImportGridData.forEach(element => {
        if (element.clientBusinessPhone) {
          const num = element.clientBusinessPhone.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['clientBusinessPhone'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
        if (element.clientCellPhone) {
          const num = element.clientCellPhone.split('-').join('').split('(').join('').split(')').join('').split(' ').join('');
          element['clientCellPhone'] = num.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
      });
    }
  }

  onStep2ValidationClick() {
    if (this.partnersGridData.length === 0) {
      return true;
    }
    for (const item of this.partnersGridData) {
      if (item.emailValidationStatus === 1 || item.emailValidationStatus === 2
        || item.emailValidationStatus === 3 || item.isEditMode === true || item.duplicateLicenseNoStatus === 1 || item.duplicateLicenseNoStatus === 2 || item.duplicateLicenseNoStatus === 3) {
        return true;
      }
    }
  }

  onStep3ValidationClick() {
    if (this.clientsGridData.length === 0) {
      return true;
    }
    for (const item of this.clientsGridData) {
      if (item.emailValidationStatus === 1 || item.emailValidationStatus === 2
        || item.emailValidationStatus === 3 || item.isEditMode === true
        || item.duplicateIDStatus === 1 || item.duplicateIDStatus === 2 || item.duplicateIDStatus === 3) {
        return true;
      }
    }
  }

  onCompleteValidationClick() {
    if (!this.firmSuperAdminForm.valid || this.partnersGridData.length === 0) {
      return true;
    }
    for (const item of this.partnersGridData) {
      if (item.emailValidationStatus === 1 || item.emailValidationStatus === 2
        || item.emailValidationStatus === 3 || item.isEditMode === true) {
        return true;
      }
    }
    for (const item of this.clientsList) {
      if (item.emailValidationStatus === 1 || item.emailValidationStatus === 2
        || item.emailValidationStatus === 3 || item.isEditMode === true) {
        return true;
      }
    }
  }

  onEntityChange() {
    let entity: any = this.clientDetailsForm.get('typeOfEntity').value;
    if (entity == 1) {
      this.customDateTitle = 'Incorporation Date';
    } else {
      this.customDateTitle = 'Formation Date';
    }
  }

  onboard() {
    this.disableBack = true;
    this.firmDetails = this.firmSuperAdminForm.value;
    if (!this.firmSuperAdminForm.valid) {
      this.showStep1 = true;
      this.disableBack = false;
      this.toaster.error('Could not finish the onboarding, please check the requested data and try again later');
    }
    let expiryDate = null;
    if (this.firmDetails.pegExpiryDate) {
      const now = new Date();
      const expiryInLocalWithTime = new Date(new Date(this.firmDetails.pegExpiryDate).setHours(now.getHours(), now.getMinutes(), now.getSeconds()));
      expiryDate = expiryInLocalWithTime.toISOString();
    }
    const onboarding = new OnboardingModel();
    onboarding.detail = {
      'emailid': this.firmDetails.email,
      'firmName': this.firmDetails.firmName,
      'pegsubscriber': this.firmDetails.pegId,
      'peglicencenumber': this.firmDetails.pegLicenseNo,
      'pegexpirydate': expiryDate,
      'firstname': this.firmDetails.firstName,
      'lastname': this.firmDetails.lastName,
      'address': this.firmDetails.address ? this.firmDetails.address.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      'bphone': this.firmDetails.businessPhone,
      'cellphone': this.firmDetails.cellPhone,
      'countryname': this.firmDetails.country ? this.firmDetails.country.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      'statename': this.firmDetails.state ? this.firmDetails.state.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      'cityname': this.firmDetails.city ? this.firmDetails.city.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      'zipcode': this.firmDetails.zipCode,
    };
    // partners
    onboarding.partners = this.partnersList.map(partner => ({
        firstname: partner.partnerFirstName,
        lastname: partner.partnerLastName,
        emailAddress: partner.partnerEmail,
        licenseNo: partner.licenseNo,
        hourlyrate: partner.hourlyRate,
        businessNo: partner.partnerBusinessPhone,
        phoneNo: partner.PartnerCellNo,
        clientList: null,
        partnerUserAcctId: 0,
        accessType: partner.accessType,
        designationId: 0,
        designationName: partner.title,
        memberid: partner.id,
        officelocation: 'Canada'
    }));
    // clients
    this.clientsList.forEach(client => {
      client.incorporationDate = this.datePipe.transform(client.incorporationDate, 'yyyy-MM-dd');
      this.typeOfEntityDetails.forEach(item => {
        if (client.typeOfEntityName == item.typeofentityname) {
          client.typeofentityid = item.typeofentityid;
        }
      });
      this.subtypeOfEntityDetails.forEach(item => {
        if (client.subentityname == item.subentityname) {
          client.typeofsubentityid = item.typeofsubentityid;
        }
      });
      if (this.user.origin_country_id == 38) {
        client.subentityname = 'S - Corp';
        client.typeofsubentityid = 1;
      }
    });
    onboarding.clients = this.clientsList.map(client => ({
        entityname: client.legalEntityName,
        firstname: client.clientFirstName ? client.clientFirstName : '',
        lastname: client.clientLastName ? client.clientLastName : '',
        pbphonenumber: client.clientBusinessPhone ? client.clientBusinessPhone : '',
        pcphonenumber: client.clientCellPhone ? client.clientCellPhone : '',
        pemailadd: client.clientEmail,
        entitytype: client.typeOfEntityName ? client.typeOfEntityName : '',
        subentityname: client.subentityname ? client.subentityname : '',
        typeofsubentityid: client.typeofsubentityid ? client.typeofsubentityid : '',
        pincorporationdate: client.incorporationDate ? client.incorporationDate : '',
        clientid: client.clientId ? client.clientId : '',
        groupName: client.groupName ? client.groupName : '',
        address: client.clientAddress ? client.clientAddress.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      countryname: client.clientCountry ? client.clientCountry.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      statename: client.clientState ? client.clientState.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
      cityname: client.clientCity ? client.clientCity.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '',
        clientZipCode: client.clientZipCode ? client.clientZipCode : '',
        engPartnerEmail: client.engPartnerEmail ? client.engPartnerEmail : ''
    }));
    // invitees
    let partnersInvitesList = this.partnersList.filter((item) => {
      return item.isInvite;
    });
    let staffInviteList = this.staffList.filter((item) => {
      return item.isInvite == true;
    });
    let allInviteList = partnersInvitesList ? partnersInvitesList : null;
    if (staffInviteList && staffInviteList.length > 0) {
      allInviteList = partnersInvitesList.concat(staffInviteList);
    }
    onboarding.invitee = allInviteList.map(item => ({email: item.partnerEmail}));
    // staff
    let staffJsonString = '';
    if (this.staffList && this.staffList.length > 0) {
      onboarding.staff = this.staffList.map(staff => ({
          id: staff.id,
          firstName: staff.partnerFirstName,
          lastName: staff.partnerLastName,
          emailAddress: staff.partnerEmail,
          businessNo: staff.partnerBusinessPhone,
          phoneNo: staff.PartnerCellNo,
          licenseNo: staff.licenseNo,
          hourlyrate: staff.hourlyRate,
          clientList: null,
          designationId: 0,
          designationName: staff.title,
          firmStaffId: 0,
          staffuseraccountid: 0,
          firmPartnerId: 0,
          accessType: staff.accessType,
          memberid: staff.id,
          officelocation: 'Canada'
      }));
    }
    this.firmService.onboardFirm(onboarding).subscribe({
      next: (res) => {
        if (res.status === 200) {
          this.authService.prepareForRefreshAfterSwitchFirm(res.data.user).subscribe(() => {
            this.authService.refreshUserProfile().subscribe(() => {
              this.toaster.success('Congratulations, your firm has been onboarded, we are redirecting you to the dashboard');
              this.router.navigateByUrl('/dashboard/members/Dashboard').then();
            });
          });
          return;
        }
        this.disableBack = false;
        res.errors.forEach(err => this.toaster.error(err));
        if (res.status === 500) {
          this.toaster.warning('Onboarding has finished but you need to login again, logging out the current session shortly');
          this.authService.logout();
        }
      },
      error: error => {
        console.log('refresh profile whole observable failed', error);
        this.toaster.error(error.error);
        this.disableBack = false;
      }
    });
  }

  public onlyChars(event, type) {
    const noSpecialCHars = event.target.value.replace(/[^a-zA-Z ]/g, '');
    if (type === 'partnerfn') {
      this.partnerDetailsForm.controls['partnerFirstName'].setValue(noSpecialCHars);
    } else if (type === 'partnerln') {
      this.partnerDetailsForm.controls['partnerLastName'].setValue(noSpecialCHars);
    } else if (type === 'firmadminfn') {
      this.firmSuperAdminForm.controls['firstName'].setValue(noSpecialCHars);
    } else if (type === 'firmadminln') {
      this.firmSuperAdminForm.controls['lastName'].setValue(noSpecialCHars);
    } else if (type === 'partnerpu') {
      this.partnerDetailsForm.controls['practiceUnit'].setValue(noSpecialCHars);
    } else if (type === 'country') {
      this.firmSuperAdminForm.controls['country'].setValue(noSpecialCHars);
    } else if (type === 'clientcpn') {
      this.clientDetailsForm.controls['contactPersonName'].setValue(noSpecialCHars);
    } else if (type === 'clientfn') {
      this.clientDetailsForm.controls['clientFirstName'].setValue(noSpecialCHars);
    } else if (type === 'clientln') {
      this.clientDetailsForm.controls['clientLastName'].setValue(noSpecialCHars);
    } else {
      return;
    }
  }

  validateSecondStep() {
    this.partnersList = this.partnersGridData.filter(p => p.role.toLowerCase() === 'partner');
    this.staffList = this.partnersGridData.filter(s => s.role.toLowerCase() === 'staff');
    this.firmDetails = this.firmSuperAdminForm.value;
    if (this.user.origin_country_id == 226) {
      this.firmDetails.pegLicenseNo = '1111';
      this.firmDetails.pegId = 'Yes';
      this.firmDetails.pegExpiryDate = '2021-01-01';
    }
    if (this.firmSuperAdminForm.valid) {
      let firmData = {
        'emailid': this.firmDetails.email,
        'firmName': this.firmDetails.firmName,
        'pegsubscriber': this.firmDetails.pegId,
        'peglicencenumber': this.firmDetails.pegLicenseNo,
        'pegexpirydate': this.firmDetails.pegExpiryDate,
        'firstname': this.firmDetails.firstName,
        'lastname': this.firmDetails.lastName,
        'address': this.firmDetails.address,
        'bphone': this.firmDetails.businessPhone,
        'cellphone': this.firmDetails.cellPhone,
        'countryname': this.firmDetails.country,
        'statename': this.firmDetails.state,
        'cityname': this.firmDetails.city,
        'zipcode': this.firmDetails.zipCode,
        'pMemberId': this.firmDetails.pMemberId,
        'pLicenseNo': this.firmDetails.pLicenseNo,
        'pHourlyRate': this.firmDetails.pHourlyRate,
        'pTitle': this.firmDetails.pTitle,
        'pofficelocation': 'Canada',
        'loginid': this.useraccountId
      };
      let firmJsonObj = {'firmdetails': firmData};
      let firmJsonString = JSON.stringify(firmJsonObj);
      let partnerData = this.partnersList.map(partner => (
        {
          firstname: partner.partnerFirstName,
          lastname: partner.partnerLastName,
          emailAddress: partner.partnerEmail,
          licenseNo: partner.licenseNo,
          hourlyrate: partner.hourlyRate,
          businessNo: partner.partnerBusinessPhone,
          phoneNo: partner.PartnerCellNo,
          clientList: null,
          partnerUserAcctId: 0,
          loginid: this.useraccountId,
          designationId: 0,
          designationName: partner.title,
          memberid: partner.id,
          accessType: partner.accessType,
          officeloaction: partner.officeloaction
        }
      ));
      let partnersJsonObj = {'partnersList': partnerData};
      let partnersJsonString = JSON.stringify(partnersJsonObj);
      this.clientsList.forEach(client => {
        client.incorporationDate = this.datePipe.transform(client.incorporationDate, 'yyyy-MM-dd');
        this.typeOfEntityDetails.forEach(item => {
          if (client.typeOfEntityName == item.typeofentityname) {
            client.typeofentityid = item.typeofentityid;
          }
        });
        this.subtypeOfEntityDetails.forEach(item => {
          if (client.subentityname == item.subentityname) {
            client.typeofsubentityid = item.typeofsubentityid;
          }
        });
        if (this.user.origin_country_id == 38) {
          client.subentityname = 'S - Corp';
          client.typeofsubentityid = 1;
        }
      });
      let clientData = this.clientsList.map(client => (
        {
          entityname: client.legalEntityName,
          pbphonenumber: client.clientBusinessPhone ? client.clientBusinessPhone : '',
          pcphonenumber: client.clientCellPhone ? client.clientCellPhone : '',
          pemailadd: client.clientEmail,
          ppwd: 'adinovis',
          firstname: client.clientFirstName ? client.clientFirstName : '',
          lastname: client.clientLastName ? client.clientLastName : '',
          entitytype: client.typeOfEntityName ? client.typeOfEntityName : '',
          subentityname: client.subentityname ? client.subentityname : '',
          typeofsubentityid: client.typeofsubentityid ? client.typeofsubentityid : '',
          pincorporationdate: client.incorporationDate ? client.incorporationDate : '',
          ploginid: this.useraccountId,
          pid: client.clientId ? client.clientId : '',
          groupName: client.groupName ? client.groupName : '',
          address: client.clientAddress,
          clientCountry: client.clientCountry ? client.clientCountry : '',
          clientState: client.clientState ? client.clientState : '',
          clientCity: client.clientCity ? client.clientCity : '',
          clientZipCode: client.clientZipCode,
          engPartnerEmail: client.engPartnerEmail ? client.engPartnerEmail : ''
        }
      ));
      let clientsJsonObj = {'clientsList': clientData};
      let clientsJsonString = JSON.stringify(clientsJsonObj);
      let partnersInvitesList = this.partnersList.filter((item) => {
        return item.isInvite;
      });
      let staffInviteList = this.staffList.filter((item) => {
        return item.isInvite == true;
      });
      let allInviteList = partnersInvitesList ? partnersInvitesList : null;
      if (staffInviteList && staffInviteList.length > 0) {
        allInviteList = partnersInvitesList.concat(staffInviteList);
      }
      let invitesData = allInviteList.map(item => (
        {
          email: item.partnerEmail
        }
      ));
      let invitesJsonObj = {'inviteList': invitesData};
      let invitesJsonString = JSON.stringify(invitesJsonObj);
      let staffJsonString = '';
      if (this.staffList && this.staffList.length > 0) {
        let staffData = this.staffList.map(staff => (
          {
            id: staff.id,
            firstName: staff.partnerFirstName,
            lastName: staff.partnerLastName,
            emailAddress: staff.partnerEmail,
            businessNo: staff.partnerBusinessPhone,
            phoneNo: staff.PartnerCellNo,
            licenseNo: staff.licenseNo,
            hourlyrate: staff.hourlyRate,
            clientList: null,
            designationId: 0,
            designationName: staff.title,
            firmStaffId: 0,
            staffuseraccountid: 0,
            firmPartnerId: 0,
            loginId: this.useraccountId,
            memberid: staff.id,
            accessType: staff.accessType,
            officelocation: 'Canada'
          }
        ));
        let staffJsonObj = {'staffList': staffData};
        staffJsonString = JSON.stringify(staffJsonObj);
      }

      let data = {
        'firmList': firmJsonString,
        'partnerList': partnersJsonString ? partnersJsonString : null,
        'clientList': clientsJsonString ? clientsJsonString : null,
        'assignedList': null,
        'inviteList': invitesJsonString ? invitesJsonString : null,
        'staffList': staffJsonString ? staffJsonString : null
      };
      this.apiService.saveFirmFourSteps(data).subscribe(() => {
        this.processType = 'manual';
        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = true;
        this.isCompletedStep2 = true;
        this.isCitiesLoading3 = true;
        this.toaster.success('Firm details saved successfully');

      }, error => {
        this.toaster.error(error.error);
      }).add(() => {
        this.clientDetailsForm.reset();
      });
    } else {
      if (!this.firmSuperAdminForm.valid) {
        this.showStep1 = true;
      }
    }
  }

  validateThirdStep() {
    let filterInviteList = this.partnersGridData.filter(partner => partner.partnerEmail !== this.firmSuperAdminForm.get('email').value);
    this.inviteGridData = new MatTableDataSource(filterInviteList);
    this.inviteAll = !(this.inviteGridData == null || this.inviteGridData.data.length == 0);
    this.clientsList = this.clientsGridData;
    this.firmDetails = this.firmSuperAdminForm.value;
    if (this.user.origin_country_id == 226) {
      this.firmDetails.pegLicenseNo = '1111';
      this.firmDetails.pegId = 'Yes';
      this.firmDetails.pegExpiryDate = '2021-01-01';
    }
    if (this.firmSuperAdminForm.valid) {
      let firmData = {
        'emailid': this.firmDetails.email,
        'firmName': this.firmDetails.firmName,
        'pegsubscriber': this.firmDetails.pegId,
        'peglicencenumber': this.firmDetails.pegLicenseNo,
        'pegexpirydate': this.firmDetails.pegExpiryDate,
        'firstname': this.firmDetails.firstName,
        'lastname': this.firmDetails.lastName,
        'address': this.firmDetails.address,
        'bphone': this.firmDetails.businessPhone,
        'cellphone': this.firmDetails.cellPhone,
        'countryname': this.firmDetails.country,
        'statename': this.firmDetails.state,
        'cityname': this.firmDetails.city,
        'zipcode': this.firmDetails.zipCode,
        'pMemberId': this.firmDetails.pMemberId,
        'pLicenseNo': this.firmDetails.pLicenseNo,
        'pHourlyRate': this.firmDetails.pHourlyRate,
        'pTitle': this.firmDetails.pTitle,
        'pofficelocation': 'Canada',
        'loginid': this.useraccountId
      };
      let firmJsonObj = {'firmdetails': firmData};
      let firmJsonString = JSON.stringify(firmJsonObj);
      let partnerData = this.partnersList.map(partner => (
        {
          firstname: partner.partnerFirstName,
          lastname: partner.partnerLastName,
          emailAddress: partner.partnerEmail,
          licenseNo: partner.licenseNo,
          hourlyrate: partner.hourlyRate,
          businessNo: partner.partnerBusinessPhone,
          phoneNo: partner.PartnerCellNo,
          clientList: null,
          partnerUserAcctId: 0,
          loginid: this.useraccountId,
          // inid: partner.id
          designationId: 0,
          designationName: partner.title,
          memberid: partner.id,
          accessType: partner.accessType,
          officelocation: 'Canada'
        }
      ));
      let partnersJsonObj = {'partnersList': partnerData};
      let partnersJsonString = JSON.stringify(partnersJsonObj);
      this.clientsList.forEach(client => {
        client.incorporationDate = this.datePipe.transform(client.incorporationDate, 'yyyy-MM-dd');
        this.typeOfEntityDetails.forEach(item => {
          if (client.typeOfEntityName == item.typeofentityname) {
            client.typeofentityid = item.typeofentityid;
          }
        });
        this.subtypeOfEntityDetails.forEach(item => {
          if (client.subentityname == item.subentityname) {
            client.typeofsubentityid = item.typeofsubentityid;
          }
        });
        if (this.user.origin_country_id == 38) {
          client.subentityname = 'S - Corp';
          client.typeofsubentityid = 1;
        }
      });
      let clientData = this.clientsList.map(client => (
        {
          entityname: client.legalEntityName,
          firstname: client.clientFirstName ? client.clientFirstName : '',
          lastname: client.clientLastName ? client.clientLastName : '',
          pbphonenumber: client.clientBusinessPhone ? client.clientBusinessPhone : '',
          pcphonenumber: client.clientCellPhone ? client.clientCellPhone : '',
          pemailadd: client.clientEmail,
          ppwd: 'adinovis',
          entitytype: client.typeOfEntityName ? client.typeOfEntityName : '',
          subentityname: client.subentityname ? client.subentityname : '',
          typeofsubentityid: client.typeofsubentityid ? client.typeofsubentityid : '',
          pincorporationdate: client.incorporationDate ? client.incorporationDate : '',
          ploginid: this.useraccountId,
          clientid: client.clientId ? client.clientId : '',
          groupName: client.groupName ? client.groupName : '',
          address: client.clientAddress,
          Countryname: client.clientCountry ? client.clientCountry : '',
          Statename: client.clientState ? client.clientState : '',
          Cityname: client.clientCity ? client.clientCity : '',
          clientZipCode: client.clientZipCode,
          engPartnerEmail: client.engPartnerEmail ? client.engPartnerEmail : ''
        }
      ));
      let clientsJsonObj = {'clientsList': clientData};
      let clientsJsonString = JSON.stringify(clientsJsonObj);
      let partnersInvitesList = this.partnersList.filter((item) => {
        return item.isInvite;
      });
      let staffInviteList = this.staffList.filter((item) => {
        return item.isInvite == true;
      });
      let allInviteList = partnersInvitesList ? partnersInvitesList : null;
      if (staffInviteList && staffInviteList.length > 0) {
        allInviteList = partnersInvitesList.concat(staffInviteList);
      }
      let invitesData = allInviteList.map(item => (
        {
          email: item.partnerEmail
        }
      ));
      let invitesJsonObj = {'inviteList': invitesData};
      let invitesJsonString = JSON.stringify(invitesJsonObj);
      let staffJsonString = '';
      if (this.staffList && this.staffList.length > 0) {
        let staffData = this.staffList.map(staff => (
          {
            id: staff.id,
            firstName: staff.partnerFirstName,
            lastName: staff.partnerLastName,
            emailAddress: staff.partnerEmail,
            businessNo: staff.partnerBusinessPhone,
            phoneNo: staff.PartnerCellNo,
            licenseNo: staff.licenseNo,
            hourlyrate: staff.hourlyRate,
            clientList: null,
            designationId: 0,
            designationName: staff.title,
            firmStaffId: 0,
            staffuseraccountid: 0,
            firmPartnerId: 0,
            loginId: this.useraccountId,
            memberid: staff.id,
            accessType: staff.accessType,
            officelocation: 'Canada'
          }
        ));
        let staffJsonObj = {'staffList': staffData};
        staffJsonString = JSON.stringify(staffJsonObj);
      }
      let data = {
        'firmList': firmJsonString,
        'partnerList': partnersJsonString ? partnersJsonString : null,
        'clientList': clientsJsonString ? clientsJsonString : null,
        'assignedList': null,
        'inviteList': invitesJsonString ? invitesJsonString : null,
        'staffList': staffJsonString ? staffJsonString : null
      };
      this.apiService.saveFirmFourSteps(data).subscribe(() => {
        this.processType = 'manual';
        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;
        this.showStep4 = true;
        this.isCompletedStep1 = true;
        this.isCompletedStep2 = true;
        this.isCompletedStep3 = true;
        this.clientDetailsForm.reset();
        this.toaster.success('Firm details saved successfully');
      }, error => {
        this.toaster.error(error.error);
      });
    } else {
      if (!this.firmSuperAdminForm.valid) {
        this.showStep1 = true;
      }
    }
  }

  isInvitedAll() {
    this.partnersList.forEach(item => {
      item.isInvite = !!this.inviteAll;
    });
    this.staffList.forEach(item => {
      item.isInvite = !!this.inviteAll;
    });
  }

  isInvited() {
    this.invitedPartners = this.inviteGridData.data.filter(x => x.isInvite === true);
    this.inviteAll = this.invitedPartners.length === this.inviteGridData.data.length;
  }

  onlyAlphNumericKeys(e) { //without space and underscore
    let specialKeys = [];
    specialKeys.push(8);  //Backspace
    specialKeys.push(9);  //Tab
    specialKeys.push(46); //Delete
    specialKeys.push(36); //Home
    specialKeys.push(35); //End
    specialKeys.push(37); //Left
    specialKeys.push(39); //Right
    let keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    return ((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 64 && keyCode <= 90) ||
      (keyCode >= 97 && keyCode <= 122) ||
      (keyCode == 35) || (specialKeys.indexOf(e.keyCode) != -1 && e.charCode != e.keyCode));
  }

  editCsv() {
    this.dialog.open(this.howtoEdit, {panelClass: 'upload-container'}).afterClosed().subscribe();
  }

  editCsvCli() {
    this.dialog.open(this.howToEditCsv, {panelClass: 'upload-container-cli'}).afterClosed().subscribe();
  }

  engagementPartner(data) {
    this.partnersList.map(e => {
      if (e.partnerEmail === data.partnerEmail) {
        e['isSelectedPartner'] = true;
        this.engPartner = e.fullName;
      } else {
        e['isSelectedPartner'] = false;
      }
    });
  }

  isSelected() {
    this.selectedClients = this.actualClientsGridData.data.filter(x => x.isChecked === true);
    this.isEnableAssignButton = this.selectedClients.length > 1;
    this.isCheckedAll = this.selectedClients.length === this.actualClientsGridData.data.length;
  }

  isSelectedAll(event) {
    if (event.checked === true) {
      this.isCheckedAll = true;
      this.selectedClients = this.actualClientsGridData.data.map(x => {
        x.isChecked = true;
        return x;
      });
      this.isEnableAssignButton = this.selectedClients.length > 1;
    } else {
      this.isCheckedAll = false;
      this.isEnableAssignButton = false;
      this.selectedClients = this.actualClientsGridData.data.map(x => {
        x.isChecked = false;
        return x;
      });
    }
  }

  unAssignPartnerToCLients() {
    this.selectedClients.forEach(e => {
      if (e.isChecked === true) {
        e['engPartnerEmail'] = '';
        e['engPartnerName'] = '';
      }
    });
    this.actualClientsGridData.data.forEach(x => x.isChecked = false);
    this.isEnableAssignButton = false;
    this.isCheckedAll = false;
    this.toaster.success('Partner unassigned successfully');
  }

  assignPartnerToCLient(partner: any) {
    this.partnersList.map(e => {
      if (e.partnerEmail === partner.partnerEmail) {
        e['isAssignedPartner'] = true;
      }
    });
    this.actualClientsGridData.data.forEach((e: any) => {
      e['engPartnerEmail'] = partner.partnerEmail;
      e['engPartnerName'] = partner.partnerFirstName + ' ' + partner.partnerLastName;
    });
    this.toaster.success('Partner assigned successfully');
  }

  reAssignPartnerToClient(partner: any, clientDetails: any) {
    this.partnersList.map(e => {
      if (e.partnerEmail === partner.partnerEmail) {
        e['isAssignedPartner'] = true;
      }
    });
    this.actualClientsGridData.data.forEach((e: any) => {
      if (e.clientEmail === clientDetails.clientEmail) {
        e['engPartnerEmail'] = partner.partnerEmail;
        e['engPartnerName'] = partner.partnerFirstName + ' ' + partner.partnerLastName;
      }
    });
    this.toaster.success('Partner assigned successfully');
  }

  openAssignPartner(partner, typeOfAction: 'assigned' | 'unassigned') {
    this.assignedPartner = partner;
    if (partner.engPartnerName && partner.engPartnerEmail) {
      this.activeUnAssignPartner = true;
      this.activeAssignPartner = false;
    } else {
      this.activeUnAssignPartner = false;
      this.activeAssignPartner = true;
    }
    if (typeOfAction === 'assigned') {
      return;
    }
    if (typeOfAction === 'unassigned') {
      this.allAssignMenu.openMenu();
    }
  }

  openReAssignPartner(partner) {
    this.assignedPartner = partner;
    this.activeUnAssignPartner = false;
    this.activeAssignPartner = true;
  }

  unAssignPartnerToCLient(client) {
    this.partnersList.map(e => {
      if (e.partnerEmail === client.engPartnerEmail && client.engPartnerEmail) {
        e['isAssignedPartner'] = false;
      }
    });
    this.actualClientsGridData.data.forEach(e => {
      if ((e.clientEmail === client.clientEmail) && (e.legalEntityName === this.assignedPartner.legalEntityName)) {
        e['engPartnerEmail'] = '';
        e['engPartnerName'] = '';
      }
    });
    this.toaster.success('Partner unassigned successfully');
  }

  skipSecondStep() {
    this.showStep1 = false;
    this.showStep2 = false;
    this.showStep3 = true;
    this.showStep4 = false;
    this.isCompletedStep2 = !(this.partnersGridData == null || this.partnersGridData.length == 0);
  }

  skipThirdStep() {
    this.showStep1 = false;
    this.showStep2 = false;
    this.showStep3 = false;
    this.showStep4 = true;
    this.isCompletedStep3 = true;
    let filterInviteList = this.partnersGridData.filter(partner => partner.partnerEmail !== this.firmSuperAdminForm.get('email').value);
    this.inviteGridData = new MatTableDataSource(filterInviteList);
    if (this.inviteGridData == null || this.inviteGridData.data.length == 0) {
      this.inviteAll = false;
    }
  }

  applyPartnerFilter(filterValue: string) {
    this.actualPartnersGridData.filter = filterValue.trim().toLowerCase();
  }

  applyClientFilter(filterValue: string) {
    this.actualClientsGridData.filter = filterValue.trim().toLowerCase();
  }

  applyInviteFilter(filterValue: string) {
    this.inviteGridData.filter = filterValue.trim().toLowerCase();
  }

  public onAddressType(address: FullAddressModel[]) {
    this.autoCompleteSuggestions.set(address);
  }

  public selectedSuggestion(matOption: MatAutocompleteSelectedEvent, isClientAddress: boolean) {
    if (isClientAddress) {
      this.clientDetailsForm.controls['clientAddress'].setValue(matOption.option.value.address);
      this.clientDetailsForm.controls['clientZipCode'].setValue(matOption.option.value.postalCode);
      this.clientDetailsForm.controls['clientCity'].setValue(matOption.option.value.city);
      this.clientDetailsForm.controls['clientState'].setValue(matOption.option.value.jurisdiction);
      this.clientDetailsForm.controls['clientCountry'].setValue(matOption.option.value.country);
    } else {
      this.firmSuperAdminForm.controls['address'].setValue(matOption.option.value.address);
      this.firmSuperAdminForm.controls['zipCode'].setValue(matOption.option.value.postalCode);
      this.firmSuperAdminForm.controls['city'].setValue(matOption.option.value.city);
      this.firmSuperAdminForm.controls['state'].setValue(matOption.option.value.jurisdiction);
      this.firmSuperAdminForm.controls['country'].setValue(matOption.option.value.country);
    }
  }

  private clientIdsValidate() {
    this.clientsGridData.forEach(element => {
      if (element.clientId) {
        const inputData = {
          'validateid':
            [{
              'id': element.clientId,
              'validatestatus': 0
            }]
        };

        this.clientService.validateClientIds(JSON.stringify(inputData)).subscribe({
          next: response => {
            if (response.status === 200 && response.data) {
              const result = JSON.parse(response.data);
              if (element['duplicateIDStatus'] === 2 || element['duplicateIDStatus'] === 3) {
                element['duplicateIDStatus'] = element['duplicateIDStatus'];
              } else {
                element['duplicateIDStatus'] = result[0].validatestatus;
              }
              element['isEditMode'] = false;
            }
          }
        });
      }
    });
  }
}
